import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, Teleport as _Teleport, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-976b60c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-admin-hub" }
const _hoisted_2 = { class: "nge-admin-modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-modal-title" }, "Delete this notification?", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-admin-modal-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-modal-sub" }, " This removes it for every user and can't be undone. ", -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-admin-modal-actions" }
const _hoisted_8 = {
  key: 1,
  class: "nge-admin-toast"
}
const _hoisted_9 = {
  key: 2,
  class: "nge-admin-subtabs"
}
const _hoisted_10 = {
  key: 9,
  class: "nge-admin-section"
}
const _hoisted_11 = {
  class: "nge-outbox-line",
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Waiting for CAVE:", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 10,
  class: "nge-pilot-admin"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Beta requests", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "People who asked to join, in the game or on connectome.quest. Let them in adds their email to Pilot testers below; then email them so they know. Add to list keeps them on the list for later, and Remove request takes them off this page.", -1 /* HOISTED */))
const _hoisted_16 = {
  class: "nge-beta-views",
  role: "tablist",
  "aria-label": "Beta requests"
}
const _hoisted_17 = ["aria-selected", "onClick"]
const _hoisted_18 = {
  key: 0,
  role: "alert"
}
const _hoisted_19 = {
  key: 1,
  class: "nge-beta-req-empty"
}
const _hoisted_20 = {
  key: 2,
  class: "nge-beta-req"
}
const _hoisted_21 = { class: "nge-pilot-name" }
const _hoisted_22 = { class: "nge-beta-req-meta" }
const _hoisted_23 = {
  key: 0,
  class: "nge-beta-req-ew"
}
const _hoisted_24 = {
  key: 1,
  class: "nge-beta-req-note"
}
const _hoisted_25 = { class: "nge-beta-req-acts" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "nge-beta-req-in" }, "In", -1 /* HOISTED */))
const _hoisted_27 = ["href"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Pilot testers", -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Invited testers can claim cells, use practice cells, sync Sheets, and contribute to the site. Existing administrators already have access.", -1 /* HOISTED */))
const _hoisted_34 = ["onSubmit"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nge-pilot-email" }, "Testers’ sign-in emails, separated by commas", -1 /* HOISTED */))
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 3,
  role: "status"
}
const _hoisted_38 = {
  key: 4,
  role: "alert"
}
const _hoisted_39 = { key: 5 }
const _hoisted_40 = {
  key: 6,
  class: "nge-pilot-find"
}
const _hoisted_41 = {
  key: 7,
  class: "nge-pilot-who",
  role: "tablist"
}
const _hoisted_42 = ["aria-selected", "onClick"]
const _hoisted_43 = {
  key: 8,
  class: "nge-pilot-sheet-err",
  role: "status"
}
const _hoisted_44 = { key: 9 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "nge-pilot-noname",
  title: "No Pyr account was found under this email. They may not have signed in yet, or they sign in with a different address."
}
const _hoisted_47 = { key: 2 }
const _hoisted_48 = {
  key: 3,
  class: "nge-pilot-joined"
}
const _hoisted_49 = {
  key: 4,
  class: "nge-pilot-invited",
  title: "Invited, but nobody has signed in to Pyr with this email yet."
}
const _hoisted_50 = {
  key: 0,
  class: "nge-pilot-web",
  title: "Not on the Pyr Users sheet: they came from the web, by a Beta request."
}
const _hoisted_51 = ["title"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "nge-admin-block" }
const _hoisted_54 = { class: "nge-admin-label" }
const _hoisted_55 = {
  key: 0,
  class: "nge-admin-editing-banner"
}
const _hoisted_56 = {
  class: "nge-admin-fmtbar",
  role: "toolbar",
  "aria-label": "Formatting"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1 /* HOISTED */))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "I", -1 /* HOISTED */))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-fmthint" }, "Paste formatted text and it keeps its bold, headings, lists and links.", -1 /* HOISTED */))
const _hoisted_62 = {
  key: 1,
  class: "nge-admin-fmtpreview"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-fmtpreview-label" }, "Preview", -1 /* HOISTED */))
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "nge-admin-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All Users", -1 /* HOISTED */))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "group" }, "Group", -1 /* HOISTED */))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "user" }, "Specific User", -1 /* HOISTED */))
const _hoisted_69 = [
  _hoisted_66,
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select group...", -1 /* HOISTED */))
const _hoisted_71 = ["value"]
const _hoisted_72 = {
  key: 1,
  class: "nge-user-pick"
}
const _hoisted_73 = {
  key: 0,
  class: "nge-user-picked"
}
const _hoisted_74 = { class: "nge-user-picked-name" }
const _hoisted_75 = {
  key: 0,
  class: "nge-user-matches"
}
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "nge-user-match-name" }
const _hoisted_78 = {
  key: 0,
  class: "nge-user-match-handle"
}
const _hoisted_79 = {
  key: 0,
  class: "nge-user-nomatch"
}
const _hoisted_80 = { class: "nge-admin-row nge-admin-row--dates" }
const _hoisted_81 = { class: "nge-admin-date-label" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Send at "),
  /*#__PURE__*/_createElementVNode("em", { class: "nge-admin-tz" }, "(ET)")
], -1 /* HOISTED */))
const _hoisted_83 = { class: "nge-admin-date-label" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { title: "After this time the notification reaches nobody new. Players who already have it keep it." }, [
  /*#__PURE__*/_createTextVNode("Stop sending at "),
  /*#__PURE__*/_createElementVNode("em", { class: "nge-admin-tz" }, "(ET)")
], -1 /* HOISTED */))
const _hoisted_85 = {
  key: 2,
  class: "nge-admin-hint"
}
const _hoisted_86 = {
  key: 3,
  class: "nge-admin-hint"
}
const _hoisted_87 = { class: "nge-admin-row" }
const _hoisted_88 = ["title"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = {
  key: 0,
  class: "nge-admin-note-inline"
}
const _hoisted_91 = {
  key: 1,
  class: "nge-admin-note-inline"
}
const _hoisted_92 = { class: "nge-admin-file-label" }
const _hoisted_93 = { class: "nge-admin-file-label nge-admin-file-label--icon" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-admin-hint" }, "Images up to 3 MB (PNG, JPEG, WebP, GIF). You can also paste a picture here with Ctrl+V. The feed always loads the small icon, not the full image.", -1 /* HOISTED */))
const _hoisted_95 = {
  key: 4,
  class: "nge-admin-pasted"
}
const _hoisted_96 = ["src"]
const _hoisted_97 = { class: "nge-admin-row" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = { key: 3 }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 5,
  class: "nge-admin-sending",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_105 = { class: "nge-admin-steps" }
const _hoisted_106 = {
  class: "nge-admin-step-mark",
  "aria-hidden": "true"
}
const _hoisted_107 = {
  key: 6,
  class: "nge-admin-error"
}
const _hoisted_108 = {
  key: 7,
  class: "nge-admin-confirm"
}
const _hoisted_109 = { class: "nge-admin-block nge-admin-notif-filters" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Show", -1 /* HOISTED */))
const _hoisted_111 = { class: "nge-admin-filter-chips" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "nge-admin-filter-count" }
const _hoisted_114 = {
  key: 0,
  class: "nge-admin-block"
}
const _hoisted_115 = { class: "nge-admin-label" }
const _hoisted_116 = { class: "nge-admin-notif-info" }
const _hoisted_117 = { class: "nge-admin-notif-meta" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = ["onClick"]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = {
  key: 1,
  class: "nge-admin-block"
}
const _hoisted_123 = { class: "nge-admin-label" }
const _hoisted_124 = { class: "nge-admin-notif-info" }
const _hoisted_125 = { class: "nge-admin-notif-meta" }
const _hoisted_126 = { key: 0 }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = ["onClick"]
const _hoisted_129 = ["onClick"]
const _hoisted_130 = {
  key: 2,
  class: "nge-admin-block"
}
const _hoisted_131 = { class: "nge-admin-label" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-hint" }, "These reach nobody new. Players who already had one still see it; Delete removes it for everyone.", -1 /* HOISTED */))
const _hoisted_133 = { class: "nge-admin-notif-info" }
const _hoisted_134 = { class: "nge-admin-notif-meta" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 3,
  class: "nge-admin-block"
}
const _hoisted_138 = {
  key: 12,
  class: "nge-admin-section"
}
const _hoisted_139 = { class: "nge-admin-block" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Create Group", -1 /* HOISTED */))
const _hoisted_141 = { class: "nge-admin-row" }
const _hoisted_142 = ["disabled"]
const _hoisted_143 = { class: "nge-admin-block" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Manage Groups", -1 /* HOISTED */))
const _hoisted_145 = { class: "nge-admin-group-list" }
const _hoisted_146 = ["onClick"]
const _hoisted_147 = {
  key: 0,
  class: "nge-admin-members"
}
const _hoisted_148 = { class: "nge-admin-row" }
const _hoisted_149 = {
  key: 0,
  class: "nge-admin-search-results"
}
const _hoisted_150 = ["onClick"]
const _hoisted_151 = { class: "nge-admin-member-list" }
const _hoisted_152 = ["onClick"]
const _hoisted_153 = {
  key: 0,
  class: "nge-admin-hint"
}
const _hoisted_154 = {
  key: 13,
  class: "nge-admin-section"
}
const _hoisted_155 = { class: "nge-admin-block" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Create Special Badge", -1 /* HOISTED */))
const _hoisted_157 = { class: "nge-admin-file-label" }
const _hoisted_158 = ["disabled"]
const _hoisted_159 = { key: 0 }
const _hoisted_160 = { key: 1 }
const _hoisted_161 = { key: 2 }
const _hoisted_162 = {
  key: 0,
  class: "nge-admin-error"
}
const _hoisted_163 = {
  key: 0,
  class: "nge-admin-block"
}
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, [
  /*#__PURE__*/_createTextVNode("Award Badge "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-admin-hint",
    style: {"font-weight":"normal","margin-left":"6px"}
  }, "Click a badge to select it")
], -1 /* HOISTED */))
const _hoisted_165 = {
  key: 0,
  class: "nge-admin-success"
}
const _hoisted_166 = {
  key: 1,
  ref: "awardSectionEl",
  class: "nge-admin-award-section"
}
const _hoisted_167 = {
  key: 0,
  class: "nge-admin-award-chosen"
}
const _hoisted_168 = ["src"]
const _hoisted_169 = {
  key: 1,
  class: "nge-admin-badge-fallback nge-admin-badge-fallback--sm"
}
const _hoisted_170 = { class: "nge-admin-award-chosen-name" }
const _hoisted_171 = { class: "nge-admin-row" }
const _hoisted_172 = { class: "nge-admin-file-label" }
const _hoisted_173 = ["disabled"]
const _hoisted_174 = {
  key: 0,
  class: "nge-admin-note-inline"
}
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-admin-hint" }, "Award to individual user:", -1 /* HOISTED */))
const _hoisted_176 = { class: "nge-admin-row" }
const _hoisted_177 = {
  key: 1,
  class: "nge-admin-search-results"
}
const _hoisted_178 = ["onClick"]
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "nge-admin-hint",
  style: {"margin-top":"10px"}
}, "Or award to entire group:", -1 /* HOISTED */))
const _hoisted_180 = { class: "nge-admin-row" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Select group...", -1 /* HOISTED */))
const _hoisted_182 = ["value"]
const _hoisted_183 = ["disabled"]
const _hoisted_184 = { class: "nge-admin-row nge-admin-badge-tools" }
const _hoisted_185 = { class: "nge-admin-hint" }
const _hoisted_186 = { class: "nge-admin-badge-grid" }
const _hoisted_187 = ["onClick", "title"]
const _hoisted_188 = ["src", "onError"]
const _hoisted_189 = {
  key: 1,
  class: "nge-admin-badge-fallback"
}
const _hoisted_190 = { class: "nge-admin-badge-name" }
const _hoisted_191 = {
  key: 2,
  class: "nge-admin-row nge-admin-badge-pager"
}
const _hoisted_192 = ["disabled"]
const _hoisted_193 = { class: "nge-admin-hint" }
const _hoisted_194 = ["disabled"]
const _hoisted_195 = {
  key: 14,
  class: "nge-admin-section"
}
const _hoisted_196 = { class: "nge-admin-block" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Register a practice cell from the current view", -1 /* HOISTED */))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-admin-hint" }, "Open the sandbox view learners should start from. Press \"Pick A and B in the viewer\", put the crosshair on a spot in the 2D view (the black and white images), hover the cell and press the A key, then do the same for the second spot and press the B key. The crosshair coordinates are what is recorded, and they stay valid after every cut and merge. The view is saved as the start state.", -1 /* HOISTED */))
const _hoisted_199 = { class: "nge-admin-row" }
const _hoisted_200 = { class: "nge-practice-kind" }
const _hoisted_201 = { class: "nge-practice-kind" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-hint" }, "Hides this panel so you can hover the cell. A small chip stays on screen with the A and B buttons.", -1 /* HOISTED */))
const _hoisted_203 = {
  key: 0,
  class: "nge-practice-picker"
}
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-practice-picker-label" }, "Practice cell", -1 /* HOISTED */))
const _hoisted_205 = { class: "nge-practice-hover" }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-practice-hover" }, [
  /*#__PURE__*/_createTextVNode("Put the crosshair on a spot in 2D (right-click there) and press the "),
  /*#__PURE__*/_createElementVNode("b", null, "A"),
  /*#__PURE__*/_createTextVNode(" key. Move it to the other side of the join and press "),
  /*#__PURE__*/_createElementVNode("b", null, "B"),
  /*#__PURE__*/_createTextVNode(". The point and the segment both come from the crosshair.")
], -1 /* HOISTED */))
const _hoisted_208 = { class: "nge-practice-picks" }
const _hoisted_209 = { class: "nge-admin-row nge-practice-picks" }
const _hoisted_210 = { class: "nge-admin-row" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-hint" }, "Or type root ids:", -1 /* HOISTED */))
const _hoisted_212 = { class: "nge-admin-row" }
const _hoisted_213 = ["disabled"]
const _hoisted_214 = {
  key: 0,
  class: "nge-admin-error"
}
const _hoisted_215 = {
  key: 1,
  class: "nge-admin-success"
}
const _hoisted_216 = { class: "nge-admin-block" }
const _hoisted_217 = {
  key: 0,
  class: "nge-admin-hint"
}
const _hoisted_218 = {
  key: 1,
  class: "nge-admin-hint"
}
const _hoisted_219 = { class: "nge-practice-main" }
const _hoisted_220 = { class: "nge-practice-status" }
const _hoisted_221 = { class: "nge-admin-hint" }
const _hoisted_222 = { class: "nge-admin-hint" }
const _hoisted_223 = {
  key: 0,
  class: "nge-admin-warn-inline"
}
const _hoisted_224 = { class: "nge-admin-row" }
const _hoisted_225 = ["disabled", "onClick"]
const _hoisted_226 = ["disabled", "onClick"]
const _hoisted_227 = ["disabled", "onClick"]
const _hoisted_228 = ["disabled", "onClick"]
const _hoisted_229 = {
  key: 15,
  class: "nge-admin-section"
}
const _hoisted_230 = { class: "nge-arcane-shelf-card" }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-arcane-shelf-head" }, "Pyr Patchtacular", -1 /* HOISTED */))
const _hoisted_232 = { class: "nge-arcane-shelf-sub" }
const _hoisted_233 = { class: "nge-arcane-grid" }
const _hoisted_234 = ["src"]
const _hoisted_235 = {
  key: 1,
  class: "nge-arcane-mystery",
  "aria-hidden": "true"
}
const _hoisted_236 = { class: "nge-arcane-tier-name" }
const _hoisted_237 = { class: "nge-arcane-tier-at" }
const _hoisted_238 = { class: "nge-arcane-unlock-card" }
const _hoisted_239 = ["src"]
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-arcane-unlock-kicker" }, "New Achievement", -1 /* HOISTED */))
const _hoisted_241 = { class: "nge-arcane-unlock-name" }
const _hoisted_242 = { class: "nge-arcane-unlock-at" }
const _hoisted_243 = { class: "nge-triage-head" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-admin-label" }, "Feedback Triage", -1 /* HOISTED */))
const _hoisted_245 = ["title"]
const _hoisted_246 = ["title"]
const _hoisted_247 = ["src"]
const _hoisted_248 = {
  key: 1,
  class: "nge-arcane-art nge-arcane-art--none",
  "aria-hidden": "true"
}
const _hoisted_249 = { class: "nge-arcane-text" }
const _hoisted_250 = { class: "nge-arcane-name" }
const _hoisted_251 = { class: "nge-arcane-bar" }
const _hoisted_252 = { class: "nge-arcane-go" }
const _hoisted_253 = ["title"]
const _hoisted_254 = { class: "nge-hud-ring-in" }
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hud-ring-word" }, "LEVEL", -1 /* HOISTED */))
const _hoisted_256 = { class: "nge-hud-level-text" }
const _hoisted_257 = { class: "nge-hud-rank" }
const _hoisted_258 = { class: "nge-triage-score-bar" }
const _hoisted_259 = { class: "nge-triage-score-goal-text" }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}, "🐛", -1 /* HOISTED */))
const _hoisted_261 = { class: "nge-triage-score-word" }
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}, "✨", -1 /* HOISTED */))
const _hoisted_263 = { class: "nge-triage-score-word" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}, "💬", -1 /* HOISTED */))
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-score-word" }, "answered", -1 /* HOISTED */))
const _hoisted_266 = ["title"]
const _hoisted_267 = {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}
const _hoisted_268 = { class: "nge-triage-score-word" }
const _hoisted_269 = ["title"]
const _hoisted_270 = {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}
const _hoisted_271 = { class: "nge-triage-score-word" }
const _hoisted_272 = {
  class: "nge-triage-score-icon",
  "aria-hidden": "true"
}
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-score-word" }, "waiting for you", -1 /* HOISTED */))
const _hoisted_274 = {
  key: 1,
  class: "nge-triage-score-word nge-triage-score-word--big"
}
const _hoisted_275 = {
  class: "nge-hud-nurro",
  "aria-hidden": "true"
}
const _hoisted_276 = ["src"]
const _hoisted_277 = {
  class: "nge-hud-spark",
  title: "Reports closed on each of the last 14 days"
}
const _hoisted_278 = { class: "nge-hud-spark-bars" }
const _hoisted_279 = ["title"]
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hud-spark-word" }, "last 14 days", -1 /* HOISTED */))
const _hoisted_281 = {
  key: 0,
  class: "nge-hud-repo",
  title: "Your commits on the live branch, and how many times it has gone live"
}
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "commits", -1 /* HOISTED */))
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "deploys", -1 /* HOISTED */))
const _hoisted_284 = {
  key: 4,
  class: "nge-triage-search-count"
}
const _hoisted_285 = {
  class: "nge-triage-kinds",
  role: "radiogroup",
  "aria-label": "Show"
}
const _hoisted_286 = ["aria-checked", "onClick"]
const _hoisted_287 = { class: "nge-triage-kind-n" }
const _hoisted_288 = ["aria-pressed", "title"]
const _hoisted_289 = { class: "nge-triage-toggle" }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show older", -1 /* HOISTED */))
const _hoisted_291 = ["disabled"]
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-hint nge-triage-howto" }, " The triage agent reads every incoming report and proposes an action. Nothing happens until you approve it, here or in Slack; both show the same list. Approving \"Send a message\" delivers the text to the reporter. Approving a fix sends it to Claude, who posts a preview in the Slack thread for you to test before anything goes live. ", -1 /* HOISTED */))
const _hoisted_293 = { class: "nge-zero-card" }
const _hoisted_294 = ["src"]
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-zero-title" }, "Triage zero!", -1 /* HOISTED */))
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-zero-sub" }, "Every report handled. Nurro is so proud of you.", -1 /* HOISTED */))
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-cheer-ring",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-cheer-check",
  "aria-hidden": "true"
}, "✓", -1 /* HOISTED */))
const _hoisted_299 = { class: "nge-triage-cheer-text" }
const _hoisted_300 = {
  key: 3,
  class: "nge-admin-error"
}
const _hoisted_301 = {
  key: 4,
  class: "nge-admin-ok"
}
const _hoisted_302 = {
  key: 5,
  class: "nge-admin-hint"
}
const _hoisted_303 = {
  key: 6,
  class: "nge-admin-hint"
}
const _hoisted_304 = ["aria-expanded", "title", "onClick"]
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-triage-group-caret",
  "aria-hidden": "true"
}, "▸", -1 /* HOISTED */))
const _hoisted_306 = {
  class: "nge-triage-group-icon",
  "aria-hidden": "true"
}
const _hoisted_307 = { class: "nge-triage-group-title" }
const _hoisted_308 = { class: "nge-triage-group-count" }
const _hoisted_309 = { class: "nge-triage-group-hint" }
const _hoisted_310 = ["data-triage-id", "onClick"]
const _hoisted_311 = { class: "nge-triage-meta" }
const _hoisted_312 = ["title"]
const _hoisted_313 = ["title"]
const _hoisted_314 = ["title"]
const _hoisted_315 = {
  key: 3,
  class: "nge-triage-rec nge-triage-rec--reply",
  title: "The submitter answered your question. Their reply is under Sent to submitter on this card."
}
const _hoisted_316 = ["title"]
const _hoisted_317 = ["title"]
const _hoisted_318 = { class: "nge-triage-src" }
const _hoisted_319 = {
  key: 6,
  class: "nge-triage-status"
}
const _hoisted_320 = {
  key: 7,
  class: "nge-triage-impl",
  title: "Marked in progress by hand. The robot is not building this."
}
const _hoisted_321 = ["href"]
const _hoisted_322 = {
  key: 0,
  class: "nge-triage-from"
}
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-from-word" }, "From ", -1 /* HOISTED */))
const _hoisted_324 = ["title"]
const _hoisted_325 = ["title"]
const _hoisted_326 = {
  key: 1,
  class: "nge-triage-title"
}
const _hoisted_327 = {
  key: 2,
  class: "nge-triage-excerpt"
}
const _hoisted_328 = ["href"]
const _hoisted_329 = {
  key: 3,
  class: "nge-triage-console"
}
const _hoisted_330 = ["href"]
const _hoisted_331 = ["href"]
const _hoisted_332 = ["onClick"]
const _hoisted_333 = ["onClick"]
const _hoisted_334 = {
  key: 3,
  class: "nge-triage-console-wrap"
}
const _hoisted_335 = ["onClick"]
const _hoisted_336 = { class: "nge-triage-console-log" }
const _hoisted_337 = {
  key: 4,
  class: "nge-triage-rationale"
}
const _hoisted_338 = {
  key: 5,
  class: "nge-triage-rationale"
}
const _hoisted_339 = ["href"]
const _hoisted_340 = ["onUpdate:modelValue"]
const _hoisted_341 = {
  key: 7,
  class: "nge-triage-rationale"
}
const _hoisted_342 = ["href"]
const _hoisted_343 = {
  key: 8,
  class: "nge-triage-spec"
}
const _hoisted_344 = {
  key: 0,
  class: "nge-triage-spec-label"
}
const _hoisted_345 = { class: "nge-triage-spec-text" }
const _hoisted_346 = {
  key: 9,
  class: "nge-triage-note"
}
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-spec-label" }, "Comment", -1 /* HOISTED */))
const _hoisted_348 = { class: "nge-triage-spec-text" }
const _hoisted_349 = ["href"]
const _hoisted_350 = {
  key: 10,
  class: "nge-triage-loop"
}
const _hoisted_351 = { key: 0 }
const _hoisted_352 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-spec-label" }, "Change", -1 /* HOISTED */))
const _hoisted_353 = { key: 1 }
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-spec-label" }, "Preview", -1 /* HOISTED */))
const _hoisted_355 = ["href"]
const _hoisted_356 = { key: 2 }
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-spec-label" }, "Waiting on", -1 /* HOISTED */))
const _hoisted_358 = { class: "nge-triage-spec-label" }
const _hoisted_359 = ["href"]
const _hoisted_360 = { key: 3 }
const _hoisted_361 = ["href"]
const _hoisted_362 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-triage-spec-label" }, "Note", -1 /* HOISTED */))
const _hoisted_363 = { class: "nge-triage-spec-text" }
const _hoisted_364 = ["href"]
const _hoisted_365 = ["src"]
const _hoisted_366 = ["href"]
const _hoisted_367 = { class: "nge-triage-reporter-by" }
const _hoisted_368 = ["onUpdate:modelValue", "onPaste", "onInput"]
const _hoisted_369 = {
  key: 0,
  class: "nge-triage-tagging"
}
const _hoisted_370 = {
  key: 1,
  class: "nge-triage-reply-attach"
}
const _hoisted_371 = ["src"]
const _hoisted_372 = { class: "nge-triage-reply-attach-state" }
const _hoisted_373 = ["onClick"]
const _hoisted_374 = { class: "nge-triage-actions" }
const _hoisted_375 = { class: "nge-admin-action-btn nge-triage-note-pick" }
const _hoisted_376 = ["onChange"]
const _hoisted_377 = ["disabled", "onClick"]
const _hoisted_378 = ["disabled", "onClick"]
const _hoisted_379 = ["onClick"]
const _hoisted_380 = ["onUpdate:modelValue", "onInput"]
const _hoisted_381 = {
  key: 12,
  class: "nge-triage-tagging"
}
const _hoisted_382 = {
  key: 13,
  class: "nge-triage-actions"
}
const _hoisted_383 = ["disabled", "onClick"]
const _hoisted_384 = {
  key: 14,
  class: "nge-triage-actions"
}
const _hoisted_385 = ["disabled", "onClick"]
const _hoisted_386 = ["disabled", "onClick"]
const _hoisted_387 = {
  key: 15,
  class: "nge-triage-actions"
}
const _hoisted_388 = ["disabled", "onClick"]
const _hoisted_389 = ["disabled", "onClick"]
const _hoisted_390 = { class: "nge-triage-claude" }
const _hoisted_391 = ["onClick"]
const _hoisted_392 = ["disabled", "onClick"]
const _hoisted_393 = ["disabled", "onClick"]
const _hoisted_394 = ["disabled", "onClick"]
const _hoisted_395 = ["disabled", "onClick"]
const _hoisted_396 = ["disabled", "title", "onClick"]
const _hoisted_397 = ["disabled", "onClick"]
const _hoisted_398 = ["disabled", "onClick"]
const _hoisted_399 = {
  key: 7,
  class: "nge-triage-copied"
}
const _hoisted_400 = {
  key: 16,
  class: "nge-triage-release"
}
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-triage-release-why" }, "Tested it? Put this exact build live from here:", -1 /* HOISTED */))
const _hoisted_402 = { class: "nge-triage-actions" }
const _hoisted_403 = ["disabled", "onClick"]
const _hoisted_404 = ["disabled", "onClick"]
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-triage-release-why" }, "Or reply in its Slack thread with:", -1 /* HOISTED */))
const _hoisted_406 = { class: "nge-triage-release-row" }
const _hoisted_407 = ["onClick"]
const _hoisted_408 = { class: "nge-triage-release-row" }
const _hoisted_409 = ["onClick"]
const _hoisted_410 = {
  key: 17,
  class: "nge-triage-beta"
}
const _hoisted_411 = ["disabled", "title", "onClick"]
const _hoisted_412 = { class: "nge-triage-beta-email" }
const _hoisted_413 = {
  key: 18,
  class: "nge-triage-beta-error",
  role: "alert"
}
const _hoisted_414 = {
  key: 19,
  class: "nge-triage-reporter"
}
const _hoisted_415 = { class: "nge-triage-spec-label" }
const _hoisted_416 = {
  key: 0,
  class: "nge-triage-spec-text nge-triage-thread-md"
}
const _hoisted_417 = ["innerHTML"]
const _hoisted_418 = ["href"]
const _hoisted_419 = ["src"]
const _hoisted_420 = {
  key: 1,
  class: "nge-triage-reporter-by"
}
const _hoisted_421 = { class: "nge-triage-reporter-by" }
const _hoisted_422 = {
  key: 1,
  class: "nge-triage-spec-text nge-triage-thread-text"
}
const _hoisted_423 = ["href"]
const _hoisted_424 = { class: "nge-triage-reporter-by" }
const _hoisted_425 = {
  key: 2,
  class: "nge-triage-reply-parts"
}
const _hoisted_426 = ["href"]
const _hoisted_427 = ["src"]
const _hoisted_428 = { class: "nge-triage-reply-chips" }
const _hoisted_429 = ["href"]
const _hoisted_430 = ["onClick"]
const _hoisted_431 = ["onClick"]
const _hoisted_432 = {
  key: 3,
  class: "nge-triage-chip nge-triage-chip--plain"
}
const _hoisted_433 = {
  key: 1,
  class: "nge-triage-reply-console"
}
const _hoisted_434 = ["disabled", "onClick"]
const _hoisted_435 = {
  class: "nge-admin-fmtbar nge-triage-fmtbar",
  role: "toolbar",
  "aria-label": "Formatting"
}
const _hoisted_436 = ["onClick"]
const _hoisted_437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1 /* HOISTED */))
const _hoisted_438 = [
  _hoisted_437
]
const _hoisted_439 = ["onClick"]
const _hoisted_440 = ["onClick"]
const _hoisted_441 = ["onClick"]
const _hoisted_442 = ["onChange"]
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-admin-fmthint" }, "Or start lines with \"- \" or \"1. \". Pasted lists keep their numbers.", -1 /* HOISTED */))
const _hoisted_444 = ["aria-pressed", "onClick"]
const _hoisted_445 = ["onUpdate:modelValue", "onPaste", "onDrop"]
const _hoisted_446 = {
  key: 0,
  class: "nge-triage-reply-attach"
}
const _hoisted_447 = ["src"]
const _hoisted_448 = { class: "nge-triage-reply-attach-state" }
const _hoisted_449 = ["onClick"]
const _hoisted_450 = {
  key: 1,
  class: "nge-admin-fmtpreview nge-triage-fmtpreview"
}
const _hoisted_451 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-admin-fmtpreview-label" }, "What they will see", -1 /* HOISTED */))
const _hoisted_452 = ["innerHTML"]
const _hoisted_453 = {
  class: "nge-triage-ask",
  title: "They get a reply form under your message: text, and if they like a screenshot, their view and their console messages. One reply per message. To hear more, ask again."
}
const _hoisted_454 = ["id"]
const _hoisted_455 = ["aria-labelledby", "data-on"]
const _hoisted_456 = ["aria-checked", "tabindex", "disabled", "onClick", "onKeydown"]
const _hoisted_457 = ["aria-checked", "tabindex", "disabled", "onClick", "onKeydown"]
const _hoisted_458 = { class: "nge-triage-ask-hint" }
const _hoisted_459 = { class: "nge-triage-actions" }
const _hoisted_460 = ["disabled", "onClick"]
const _hoisted_461 = ["disabled", "onClick"]
const _hoisted_462 = ["disabled", "onClick"]
const _hoisted_463 = ["disabled", "onClick"]
const _hoisted_464 = ["disabled", "onClick"]
const _hoisted_465 = ["onClick"]
const _hoisted_466 = {
  key: 0,
  class: "nge-triage-col-empty"
}
const _hoisted_467 = ["src"]
const _hoisted_468 = ["aria-selected", "onMousedown"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Delete is irreversible and removes the notification for EVERYONE, so\n         it takes a deliberate confirm, then acknowledges that it happened. "),
    ($setup.pendingDelete)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "nge-admin-modal-backdrop",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($setup.pendingDelete = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" “" + _toDisplayString($setup.pendingDelete.title) + "”", 1 /* TEXT */),
              _hoisted_5,
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "nge-admin-modal-danger",
                onClick: $setup.confirmDelete
              }, "Delete"),
              _createElementVNode("button", {
                class: "nge-admin-modal-cancel",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.pendingDelete = null))
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.deleteDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createTextVNode(" ✓ " + _toDisplayString($setup.deleteDone) + " ", 1 /* TEXT */),
          _createElementVNode("button", {
            class: "nge-admin-confirm-x",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.deleteDone = ''))
          }, "×")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Sub-tabs "),
    (!$props.standalone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'notifications' }]),
            onClick: _cache[3] || (_cache[3] = $event => ($setup.adminSubTab = 'notifications'))
          }, "Notifications", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'groups' }]),
            onClick: _cache[4] || (_cache[4] = $event => ($setup.adminSubTab = 'groups'))
          }, "Groups", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab nge-admin-subtab--badges", { 'nge-admin-subtab--active': $setup.adminSubTab === 'badges' }]),
            onClick: _cache[5] || (_cache[5] = $event => ($setup.adminSubTab = 'badges'))
          }, "Special Badges", 2 /* CLASS */),
          _createCommentVNode(" Triage lives on its own page: the full board, in a new tab (Ames 2026-10-05). "),
          _createElementVNode("a", {
            class: "nge-admin-subtab nge-admin-subtab--triage",
            href: $setup.boardUrl,
            target: "_blank",
            rel: "noopener",
            title: "Opens the triage board in a new tab"
          }, "Triage ↗"),
          _createElementVNode("a", {
            class: "nge-admin-subtab nge-admin-subtab--triage",
            href: $setup.todoBoardUrl,
            target: "_blank",
            rel: "noopener",
            title: "Opens the admins' own To do board in a new tab"
          }, "To do ↗"),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'practice' }]),
            onClick: _cache[6] || (_cache[6] = $event => ($setup.adminSubTab = 'practice'))
          }, "Practice cells", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'pilot' }]),
            onClick: _cache[7] || (_cache[7] = $event => ($setup.adminSubTab = 'pilot'))
          }, "Pilot testers", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'access' }]),
            onClick: _cache[8] || (_cache[8] = $event => ($setup.adminSubTab = 'access')),
            title: "Players' ten examples for retina access"
          }, "Access requests", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'tests' }]),
            onClick: _cache[9] || (_cache[9] = $event => ($setup.adminSubTab = 'tests')),
            title: "Every Proofreading Test try: the score, what was missed, and the player's cell"
          }, "Test tries", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'celltypes' }]),
            onClick: _cache[10] || (_cache[10] = $event => ($setup.adminSubTab = 'celltypes')),
            title: "Are the cell types the game logged really in CAVE?"
          }, "Cell types", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'hunts' }]),
            onClick: _cache[11] || (_cache[11] = $event => ($setup.adminSubTab = 'hunts')),
            title: "Timed merger hunts, with gold, silver and bronze Achievements"
          }, "Hunts", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'interneurons' }]),
            onClick: _cache[12] || (_cache[12] = $event => ($setup.adminSubTab = 'interneurons')),
            title: "Super Quests (giant MEC interneurons), and the active time players spend on each claim"
          }, "Super Quests", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'tutorialEdits' }]),
            onClick: _cache[13] || (_cache[13] = $event => ($setup.adminSubTab = 'tutorialEdits')),
            title: "Tutorial boxes admins reworded, and suggestions waiting for approval"
          }, "Tutorial edits", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-admin-subtab", { 'nge-admin-subtab--active': $setup.adminSubTab === 'tutorialTimes' }]),
            onClick: _cache[14] || (_cache[14] = $event => ($setup.adminSubTab = 'tutorialTimes')),
            title: "How long players spend on each tutorial box"
          }, "Tutorial times", 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Tutorial edits (Ames 2026-10-25): the pencil on a tutorial box ── "),
    ($setup.adminSubTab === 'tutorialEdits')
      ? (_openBlock(), _createBlock($setup["TutorialEditsTab"], { key: 3 }))
      : _createCommentVNode("v-if", true),
    ($setup.adminSubTab === 'tutorialTimes')
      ? (_openBlock(), _createBlock($setup["TutorialTimesTab"], { key: 4 }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Access requests (Ames 2026-10-16): the Dataset Access form, in the game ── "),
    ($setup.adminSubTab === 'access')
      ? (_openBlock(), _createBlock($setup["AccessRequestsTab"], { key: 5 }))
      : _createCommentVNode("v-if", true),
    ($setup.adminSubTab === 'hunts')
      ? (_openBlock(), _createBlock($setup["HuntsAdminTab"], { key: 6 }))
      : _createCommentVNode("v-if", true),
    ($setup.adminSubTab === 'interneurons')
      ? (_openBlock(), _createBlock($setup["InterneuronQuestsAdminTab"], { key: 7 }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Proofreading Test tries (Ames 2026-10-21): every try, and the player's cell ── "),
    ($setup.adminSubTab === 'tests')
      ? (_openBlock(), _createBlock($setup["TestTriesTab"], { key: 8 }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Cell types: the game's log against CAVE ── "),
    ($setup.adminSubTab === 'celltypes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createCommentVNode(" Saves waiting for CAVE (cave_outbox.ts): every player, every dataset. "),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            ($setup.outboxSummary === null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("checking…")
                ], 64 /* STABLE_FRAGMENT */))
              : ($setup.outboxSummary.installed === false)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("not switched on yet (run supabase-cave-outbox.sql).")
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.outboxSummary.error)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("could not be read (" + _toDisplayString($setup.outboxSummary.error) + ").", 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (!$setup.outboxSummary.waiting)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode("nothing. Every save reached CAVE.")
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(_toDisplayString($setup.outboxSummary.waiting) + " save" + _toDisplayString($setup.outboxSummary.waiting === 1 ? '' : 's') + " (" + _toDisplayString($setup.outboxSummary.byKind?.complete || 0) + " completion" + _toDisplayString($setup.outboxSummary.byKind?.complete === 1 ? '' : 's') + ", " + _toDisplayString($setup.outboxSummary.byKind?.cell_type || 0) + " cell type" + _toDisplayString($setup.outboxSummary.byKind?.cell_type === 1 ? '' : 's') + ") from " + _toDisplayString($setup.outboxSummary.players) + " player" + _toDisplayString($setup.outboxSummary.players === 1 ? '' : 's') + ", the oldest " + _toDisplayString($setup.relTime($setup.outboxSummary.oldest)) + ". Each goes out from the player's own browser when CAVE is back and they have Pyr open. ", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
          ]),
          _createVNode($setup["CellTypeCheck"])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Notifications ── "),
    ($setup.adminSubTab === 'pilot')
      ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.BETA_VIEWS, (v) => {
              return _createElementVNode("button", {
                key: v.key,
                role: "tab",
                "aria-selected": $setup.betaView === v.key,
                class: _normalizeClass({ 'nge-beta-view--on': $setup.betaView === v.key }),
                onClick: $event => ($setup.betaView = v.key)
              }, [
                _createTextVNode(_toDisplayString(v.label) + " ", 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.betaCount[v.key]), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_17)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          ($setup.betaError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($setup.betaError), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (!$setup.betaShown.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.betaView === 'waiting' ? ($setup.betaRequests.length ? 'Nobody is waiting.' : 'No requests yet.') : 'Nobody here.'), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.betaShown, (r) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: r.id
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("b", _hoisted_21, _toDisplayString(r.name || 'No name'), 1 /* TEXT */),
                      _createTextVNode(" · " + _toDisplayString(r.email) + " ", 1 /* TEXT */),
                      _createElementVNode("i", _hoisted_22, _toDisplayString($setup.betaWhen(r.at)) + _toDisplayString(r.site ? ', from connectome.quest' : ', in the game'), 1 /* TEXT */),
                      (r.ewName || r.ewRank)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "EyeWire: " + _toDisplayString([r.ewName, r.ewRank].filter(Boolean).join(', ')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (r.note)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(r.note), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("span", _hoisted_25, [
                      ($setup.betaStateOf(r) === 'in')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_26,
                            _createElementVNode("a", {
                              class: "nge-beta-req-mail",
                              href: $setup.betaMailto(r)
                            }, "Email them", 8 /* PROPS */, _hoisted_27)
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              disabled: $setup.betaBusy === r.email,
                              onClick: $event => ($setup.letBetaIn(r))
                            }, _toDisplayString($setup.betaBusy === r.email ? 'Saving…' : 'Let them in'), 9 /* TEXT, PROPS */, _hoisted_28),
                            ($setup.betaStateOf(r) !== 'listed')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  disabled: $setup.betaBusy === r.email,
                                  onClick: $event => ($setup.markBeta(r, 'listed'))
                                }, "Add to list", 8 /* PROPS */, _hoisted_29))
                              : _createCommentVNode("v-if", true),
                            ($setup.betaStateOf(r) !== 'removed')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  disabled: $setup.betaBusy === r.email,
                                  onClick: $event => ($setup.markBeta(r, 'removed'))
                                }, "Remove request", 8 /* PROPS */, _hoisted_30))
                              : _createCommentVNode("v-if", true),
                            ($setup.betaStateOf(r) !== 'waiting')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  disabled: $setup.betaBusy === r.email,
                                  onClick: $event => ($setup.markBeta(r, 'waiting'))
                                }, "Back to waiting", 8 /* PROPS */, _hoisted_31))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])),
          _hoisted_32,
          _hoisted_33,
          _createElementVNode("form", {
            onSubmit: _withModifiers($setup.invitePilot, ["prevent"])
          }, [
            _hoisted_35,
            _withDirectives(_createElementVNode("input", {
              id: "nge-pilot-email",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.pilotEmail) = $event)),
              type: "text",
              required: "",
              autocomplete: "off",
              spellcheck: "false",
              placeholder: "tester@example.com, another@example.com"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.pilotEmail]
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: $setup.pilotBusy
            }, _toDisplayString($setup.pilotBusy ? 'Saving…' : 'Add testers'), 9 /* TEXT, PROPS */, _hoisted_36)
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_34),
          ($setup.pilotNote)
            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString($setup.pilotNote), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.pilotError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString($setup.pilotError), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (!$setup.pilotRows.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_39, "No additional testers invited yet."))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.pilotSearch) = $event)),
                  type: "search",
                  autocomplete: "off",
                  placeholder: "Search by name or email",
                  "aria-label": "Search testers by name or email",
                  onKeydown: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                  onKeyup: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
                  onKeypress: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelText, $setup.pilotSearch]
                ]),
                _createElementVNode("span", null, _toDisplayString($setup.pilotSearch.trim() || $setup.pilotWho !== 'all' ? `${$setup.pilotShown.length} of ${$setup.pilotRows.length}` : `${$setup.pilotRows.length} testers`), 1 /* TEXT */)
              ])),
          ($setup.pilotRows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.PILOT_WHO.filter(x => x !== 'web' || $setup.pilotSheet), (w) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: w,
                    class: _normalizeClass(["nge-pilot-who-btn", { 'is-on': $setup.pilotWho === w }]),
                    role: "tab",
                    "aria-selected": $setup.pilotWho === w,
                    onClick: $event => ($setup.pilotWho = w)
                  }, _toDisplayString(w === 'all' ? `All ${$setup.pilotRows.length}` : w === 'joined' ? `Joined ${$setup.pilotJoinedCount}` : w === 'web' ? `From the web ${$setup.pilotWebCount}` : `Invited, not joined ${$setup.pilotRows.length - $setup.pilotJoinedCount}`), 11 /* TEXT, CLASS, PROPS */, _hoisted_42))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.pilotSheetError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Not checked against the Pyr Users sheet: " + _toDisplayString($setup.pilotSheetError) + " Share the sheet with eyewire-ii-spreadsheet@eyewire-ii.iam.gserviceaccount.com (Viewer) so Pyr can read it. ", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.pilotRows.length && !$setup.pilotShown.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_44, "Nobody matches \"" + _toDisplayString($setup.pilotSearch.trim()) + "\".", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pilotShown, (member) => {
              return (_openBlock(), _createElementBlock("li", {
                key: member.email
              }, [
                _createElementVNode("span", null, [
                  ($setup.pilotJoined(member))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "nge-pilot-name nge-pilot-name--link",
                        title: "Open their profile",
                        onClick: $event => ($setup.openPilotProfile(member))
                      }, _toDisplayString($setup.pilotNames[member.email.toLowerCase()] || 'Their profile'), 9 /* TEXT, PROPS */, _hoisted_45))
                    : (_openBlock(), _createElementBlock("i", _hoisted_46, "no Pyr name yet")),
                  _createTextVNode(" · " + _toDisplayString(member.email) + " · ", 1 /* TEXT */),
                  (!member.enabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Access paused"))
                    : ($setup.pilotJoined(member))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Joined"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, "Invited, not joined yet")),
                  ($setup.pilotSheet)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(" · "),
                        ($setup.pilotFromWeb(member))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "From the web"))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "nge-pilot-sheet",
                              title: `On the Pyr Users sheet, tab ${$setup.pilotSheet[member.email.toLowerCase()]}`
                            }, "On the sheet", 8 /* PROPS */, _hoisted_51))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  onClick: $event => ($setup.setPilot(member.email,!member.enabled))
                }, _toDisplayString(member.enabled ? 'Pause access' : 'Restore access'), 9 /* TEXT, PROPS */, _hoisted_52)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.adminSubTab === 'notifications')
      ? (_openBlock(), _createElementBlock("div", {
          key: 11,
          class: "nge-admin-section",
          onPaste: $setup.onNotifImagePaste
        }, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("label", _hoisted_54, _toDisplayString($setup.editingId != null ? 'Editing Notification' : 'Send Notification'), 1 /* TEXT */),
            ($setup.editingId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, " Editing \"" + _toDisplayString($setup.notifTitle || 'this notification') + "\". Press Save Changes below and it updates for everyone who can see it; no new notification is sent. ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.notifTitle) = $event)),
              class: "nge-admin-input",
              placeholder: "Title"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.notifTitle]
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                type: "button",
                title: "Bold",
                onClick: _cache[21] || (_cache[21] = $event => ($setup.fmtWrap('**', 'bold text')))
              }, _hoisted_58),
              _createElementVNode("button", {
                type: "button",
                title: "Italic",
                onClick: _cache[22] || (_cache[22] = $event => ($setup.fmtWrap('*', 'italic text')))
              }, _hoisted_60),
              _createElementVNode("button", {
                type: "button",
                title: "Heading",
                onClick: _cache[23] || (_cache[23] = $event => ($setup.fmtLines('## ', 'Heading')))
              }, "H"),
              _createElementVNode("button", {
                type: "button",
                title: "Bullet list",
                onClick: _cache[24] || (_cache[24] = $event => ($setup.fmtLines('- ', 'List item')))
              }, "• List"),
              _createElementVNode("button", {
                type: "button",
                title: "Numbered list",
                onClick: _cache[25] || (_cache[25] = $event => ($setup.fmtLines(i => `${i + 1}. `, 'List item')))
              }, "1. List"),
              _createElementVNode("button", {
                type: "button",
                title: "Link",
                onClick: _cache[26] || (_cache[26] = $event => ($setup.fmtLink()))
              }, "Link"),
              _hoisted_61
            ]),
            _withDirectives(_createElementVNode("textarea", {
              ref: "notifBodyEl",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (($setup.notifBody) = $event)),
              class: "nge-admin-textarea",
              rows: "6",
              placeholder: "Message body...",
              onPaste: _cache[28] || (_cache[28] = $event => ($setup.onNotifPaste($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [$setup["vAutogrow"]],
              [_vModelText, $setup.notifBody]
            ]),
            ($setup.notifBody.trim())
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", {
                    class: "nge-admin-fmtpreview-body",
                    innerHTML: $setup.notifPreview
                  }, null, 8 /* PROPS */, _hoisted_64)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_65, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.notifTargetType) = $event)),
                class: "nge-admin-select"
              }, _hoisted_69, 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.notifTargetType]
              ]),
              ($setup.notifTargetType === 'group')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($setup.notifTargetId) = $event)),
                    class: "nge-admin-select"
                  }, [
                    _hoisted_70,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: g.id,
                        value: String(g.id)
                      }, _toDisplayString(g.name), 9 /* TEXT, PROPS */, _hoisted_71))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */)), [
                    [_vModelSelect, $setup.notifTargetId]
                  ])
                : _createCommentVNode("v-if", true),
              ($setup.notifTargetType === 'user')
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    ($setup.userPicked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString($setup.userLabel($setup.userPicked)), 1 /* TEXT */),
                          _createElementVNode("button", {
                            type: "button",
                            class: "nge-user-picked-x",
                            title: "Choose someone else",
                            onClick: $setup.clearPickedUser
                          }, "×")
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (($setup.userQuery) = $event)),
                            class: "nge-admin-input",
                            placeholder: "Name or username",
                            autocomplete: "off",
                            onInput: $setup.onUserQuery,
                            onKeydown: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"]))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelText, $setup.userQuery]
                          ]),
                          ($setup.userQuery.trim().length >= 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userMatches, (u) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: u.id,
                                    type: "button",
                                    class: "nge-user-match",
                                    onClick: $event => ($setup.pickUser(u))
                                  }, [
                                    _createElementVNode("span", _hoisted_77, _toDisplayString(u.display_name || 'Unnamed player'), 1 /* TEXT */),
                                    (u.username)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_78, "@" + _toDisplayString(u.username), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ], 8 /* PROPS */, _hoisted_76))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (!$setup.userMatches.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString($setup.userSearching ? 'Searching…' : 'No player found with that name'), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("label", _hoisted_81, [
                _hoisted_82,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => (($setup.notifSendAt) = $event)),
                  class: "nge-admin-date-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.notifSendAt]
                ])
              ]),
              _createElementVNode("label", _hoisted_83, [
                _hoisted_84,
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (($setup.notifExpiresAt) = $event)),
                  class: "nge-admin-date-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.notifExpiresAt]
                ])
              ])
            ]),
            ($setup.notifSendAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_85, " Sends " + _toDisplayString($setup.formatEt($setup.etNaiveToUtcIso($setup.notifSendAt))) + " — times are Eastern regardless of your own timezone. ", 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_86, "Leave \"Send at\" empty to send immediately")),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("label", {
                class: "nge-admin-check",
                title: $setup.notifTargetType === 'all' ? '' : 'Only notifications sent to everyone can be posted to chat'
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => (($setup.notifPostToChat) = $event)),
                  disabled: $setup.notifTargetType !== 'all'
                }, null, 8 /* PROPS */, _hoisted_89), [
                  [_vModelCheckbox, $setup.notifPostToChat]
                ]),
                _createTextVNode(" Also post to chat")
              ], 8 /* PROPS */, _hoisted_88),
              ($setup.notifTargetType !== 'all')
                ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Chat posts are for notifications sent to everyone."))
                : _createCommentVNode("v-if", true),
              ($setup.notifPostToChat && $setup.isScheduledForLater)
                ? (_openBlock(), _createElementBlock("span", _hoisted_91, " Chat post happens when it sends, not now. "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("label", _hoisted_92, [
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/png,image/jpeg,image/webp,image/gif",
                  onChange: $setup.onNotifImageChange,
                  class: "nge-admin-file-input"
                }, null, 32 /* HYDRATE_EVENTS */),
                _createTextVNode(" " + _toDisplayString($setup.notifImageFile ? $setup.notifImageFile.name : 'Attach image...'), 1 /* TEXT */)
              ]),
              _createCommentVNode(" Optional small icon. The feed renders a thumbnail per card, so a\n               purpose-made icon both looks better at 120px than an auto-crop of\n               the hero image and keeps the feed light. "),
              _createElementVNode("label", _hoisted_93, [
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/png,image/jpeg,image/webp,image/gif",
                  onChange: $setup.onNotifIconChange,
                  class: "nge-admin-file-input"
                }, null, 32 /* HYDRATE_EVENTS */),
                _createTextVNode(" " + _toDisplayString($setup.notifIconFile ? $setup.notifIconFile.name : 'Feed icon (optional)...'), 1 /* TEXT */)
              ])
            ]),
            _hoisted_94,
            ($setup.notifImagePreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _createElementVNode("img", {
                    src: $setup.notifImagePreview,
                    alt: "The image that will be sent"
                  }, null, 8 /* PROPS */, _hoisted_96),
                  _createElementVNode("span", null, _toDisplayString($setup.notifImageFile?.name) + " · " + _toDisplayString((($setup.notifImageFile?.size || 0) / 1024).toFixed(0)) + " KB", 1 /* TEXT */),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nge-admin-action-btn",
                    onClick: _cache[37] || (_cache[37] = $event => ($setup.notifImageFile = null))
                  }, "Remove")
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("button", {
                class: "nge-admin-primary-btn",
                disabled: $setup.notifSending || !$setup.notifReady,
                onClick: $setup.sendNotification
              }, [
                ($setup.notifSent)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_99, "✓ Saved!"))
                  : ($setup.notifSending)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_100, _toDisplayString($setup.notifSteps.find(x => x.key === $setup.notifSendStage)?.label || 'Sending') + "…", 1 /* TEXT */))
                    : ($setup.editingId != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_101, "Save Changes"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_102, "Send Notification"))
              ], 8 /* PROPS */, _hoisted_98),
              _createElementVNode("button", {
                class: "nge-admin-cancel-btn nge-admin-preview-btn",
                type: "button",
                disabled: !$setup.notifTitle.trim() && !$setup.notifBody.trim(),
                title: "See this notification as players will, before it is sent. Nothing is sent or saved.",
                onClick: $setup.previewNotification
              }, "Preview", 8 /* PROPS */, _hoisted_103),
              ($setup.editingId != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-admin-cancel-btn",
                    onClick: $setup.cancelEdit
                  }, "Cancel edit"))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" While it sends: a neuron that grows a part for each real step. "),
            ($setup.notifSending)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createVNode($setup["GrowingNeuron"], {
                    stage: $setup.notifStepsDone,
                    stages: $setup.notifSteps.length,
                    seed: $setup.notifSeed
                  }, null, 8 /* PROPS */, ["stage", "stages", "seed"]),
                  _createElementVNode("ul", _hoisted_105, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notifSteps, (st) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: st.key,
                        class: _normalizeClass(["nge-admin-step", `nge-admin-step--${$setup.notifStepState(st.key)}`])
                      }, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString($setup.notifStepState(st.key) === 'done' ? '✓' : ''), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(st.label), 1 /* TEXT */)
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.notifError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, "⚠ " + _toDisplayString($setup.notifError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Explicit confirmation of what actually happened, including the\n             scheduled time, rather than a transient \"Sent!\" on the button. "),
            ($setup.notifConfirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                  _createTextVNode(" ✓ " + _toDisplayString($setup.notifConfirm) + " ", 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "nge-admin-confirm-x",
                    onClick: _cache[38] || (_cache[38] = $event => ($setup.notifConfirm = ''))
                  }, "×")
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Category filters. Auto-generated notifications (per-user badges,\n           weekly recaps, help replies) are off by default so the list shows the\n           admin's own broadcasts + weekly champions; toggle a chip to reveal a\n           category. Persisted per browser. "),
          _createElementVNode("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("div", _hoisted_111, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.NOTIF_CATEGORIES, (cat) => {
                return _createElementVNode("button", {
                  key: cat.key,
                  class: _normalizeClass(["nge-admin-filter-chip", { 'nge-admin-filter-chip--on': $setup.visibleCategories.has(cat.key) }]),
                  onClick: $event => ($setup.toggleNotifCategory(cat.key))
                }, [
                  _createTextVNode(_toDisplayString(cat.label) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_113, _toDisplayString($setup.categoryCount(cat.key)), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_112)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ]),
          _createCommentVNode(" Notifications by lifecycle stage. All three come from ONE paginated\n           admin query (send_at DESC), so future-dated rows sort to the top and\n           the scheduled queue is always on the first page. Loading every\n           notification ever just to render this panel would get slow for no\n           benefit, hence \"Load more\". "),
          ($setup.scheduledNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _createElementVNode("label", _hoisted_115, "Scheduled (" + _toDisplayString($setup.scheduledNotifs.length) + ")", 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduledNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--queued"
                  }, [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_117, [
                        _createTextVNode(_toDisplayString(n.target_type) + " · sends " + _toDisplayString($setup.formatEt(n.send_at)) + " ", 1 /* TEXT */),
                        (n.post_to_chat)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_118, " · posts to chat"))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.viewNotification(n)),
                      title: "See this notification as players see it. Nothing changes."
                    }, "View", 8 /* PROPS */, _hoisted_119),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.startEdit(n)),
                      title: "Edit this notification (changes it in place, sends nothing new)"
                    }, "✎ Edit", 8 /* PROPS */, _hoisted_120),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Cancel this scheduled notification"
                    }, "×", 8 /* PROPS */, _hoisted_121)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.activeNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _createElementVNode("label", _hoisted_123, "Active (" + _toDisplayString($setup.activeNotifs.length) + ")", 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--active"
                  }, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_125, [
                        _createTextVNode(_toDisplayString(n.target_type) + " · sent " + _toDisplayString($setup.formatEt(n.send_at)) + " ", 1 /* TEXT */),
                        (n.expires_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_126, " · stops sending " + _toDisplayString($setup.formatEt(n.expires_at)), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.viewNotification(n)),
                      title: "See this notification as players see it. Nothing changes."
                    }, "View", 8 /* PROPS */, _hoisted_127),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.startEdit(n)),
                      title: "Edit this notification (changes it in place, sends nothing new)"
                    }, "✎ Edit", 8 /* PROPS */, _hoisted_128),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Delete"
                    }, "×", 8 /* PROPS */, _hoisted_129)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Expired: no edit button. Editing something nobody can see any more\n           would just be misleading, so these are read-only apart from delete. "),
          ($setup.expiredNotifs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _createElementVNode("label", _hoisted_131, "No longer sending (" + _toDisplayString($setup.expiredNotifs.length) + ")", 1 /* TEXT */),
                _hoisted_132,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.expiredNotifs, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: n.id,
                    class: "nge-admin-notif-row nge-admin-notif-row--expired"
                  }, [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("strong", null, _toDisplayString(n.title), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_134, _toDisplayString(n.target_type) + " · stopped sending " + _toDisplayString($setup.formatEt(n.expires_at)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-edit-btn",
                      onClick: $event => ($setup.viewNotification(n)),
                      title: "See this notification as players see it. Nothing changes."
                    }, "View", 8 /* PROPS */, _hoisted_135),
                    _createElementVNode("button", {
                      class: "nge-admin-delete-btn",
                      onClick: $event => ($setup.requestDelete(n)),
                      title: "Delete"
                    }, "×", 8 /* PROPS */, _hoisted_136)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.backend.adminNotifHasMore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                _createElementVNode("button", {
                  class: "nge-admin-more-btn",
                  onClick: _cache[39] || (_cache[39] = $event => ($setup.backend.loadAdminNotifications(true)))
                }, "Load more")
              ]))
            : _createCommentVNode("v-if", true)
        ], 32 /* HYDRATE_EVENTS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Groups ── "),
    ($setup.adminSubTab === 'groups')
      ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
          _createElementVNode("div", _hoisted_139, [
            _hoisted_140,
            _createElementVNode("div", _hoisted_141, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => (($setup.newGroupName) = $event)),
                class: "nge-admin-input",
                placeholder: "Group name (e.g. Scythes)"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.newGroupName]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => (($setup.newGroupColor) = $event)),
                type: "color",
                class: "nge-admin-color",
                title: "Group color"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.newGroupColor]
              ]),
              _createElementVNode("button", {
                class: "nge-admin-action-btn",
                onClick: $setup.createGroup,
                disabled: !$setup.newGroupName.trim()
              }, "Create", 8 /* PROPS */, _hoisted_142)
            ])
          ]),
          _createElementVNode("div", _hoisted_143, [
            _hoisted_144,
            _createElementVNode("div", _hoisted_145, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: g.id,
                  class: _normalizeClass(["nge-admin-group-chip", { 'nge-admin-group-chip--active': $setup.selectedGroupId === g.id }]),
                  style: _normalizeStyle({ borderColor: g.color }),
                  onClick: $event => ($setup.selectGroup(g.id))
                }, [
                  _createElementVNode("span", {
                    class: "nge-admin-group-dot",
                    style: _normalizeStyle({ background: g.color })
                  }, null, 4 /* STYLE */),
                  _createTextVNode(" " + _toDisplayString(g.name), 1 /* TEXT */)
                ], 14 /* CLASS, STYLE, PROPS */, _hoisted_146))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($setup.selectedGroupId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                  _createElementVNode("div", _hoisted_148, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => (($setup.memberSearch) = $event)),
                      onInput: $setup.onMemberSearch,
                      class: "nge-admin-input",
                      placeholder: "Search users to add..."
                    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelText, $setup.memberSearch]
                    ])
                  ]),
                  ($setup.memberSearchResults.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.memberSearchResults, (u) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: u.id,
                            class: "nge-admin-search-item",
                            onClick: $event => ($setup.addMember(u.id))
                          }, " + " + _toDisplayString(u.display_name || u.email), 9 /* TEXT, PROPS */, _hoisted_150))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_151, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupMembers, (m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: m.user_id,
                        class: "nge-admin-member-row"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(m.display_name || m.email || m.user_id), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "nge-admin-delete-btn",
                          onClick: $event => ($setup.removeMember(m.user_id))
                        }, "×", 8 /* PROPS */, _hoisted_152)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($setup.groupMembers.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, "No members yet."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ── Special Badges ── "),
    ($setup.adminSubTab === 'badges')
      ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
          _createElementVNode("div", _hoisted_155, [
            _hoisted_156,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => (($setup.badgeName) = $event)),
              class: "nge-admin-input",
              placeholder: "Badge name"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.badgeName]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => (($setup.badgeSlug) = $event)),
              class: "nge-admin-input",
              placeholder: "Code name (optional; made from the name when empty)",
              title: "How the game finds this one when it gives it out by itself. The Merger Sandbox award is: merger-sandbox"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.badgeSlug]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => (($setup.badgeDesc) = $event)),
              class: "nge-admin-textarea",
              rows: "2",
              placeholder: "Description..."
            }, null, 512 /* NEED_PATCH */), [
              [$setup["vAutogrow"]],
              [_vModelText, $setup.badgeDesc]
            ]),
            _createElementVNode("label", _hoisted_157, [
              _createElementVNode("input", {
                type: "file",
                accept: "image/*",
                onChange: $setup.onBadgeImageChange,
                class: "nge-admin-file-input"
              }, null, 32 /* HYDRATE_EVENTS */),
              _createTextVNode(" " + _toDisplayString($setup.badgeImageFile ? $setup.badgeImageFile.name : 'Choose badge image...'), 1 /* TEXT */)
            ]),
            _createElementVNode("button", {
              class: "nge-admin-primary-btn",
              disabled: $setup.badgeCreating || !$setup.badgeName.trim() || !$setup.badgeImageFile,
              onClick: $setup.createBadge
            }, [
              ($setup.badgeCreated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_159, "✓ Created!"))
                : ($setup.badgeCreating)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_160, "Creating..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_161, "Create Badge"))
            ], 8 /* PROPS */, _hoisted_158),
            ($setup.badgeError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_162, "⚠ " + _toDisplayString($setup.badgeError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.backend.specialBadges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                _hoisted_164,
                ($setup.awardSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString($setup.awardSuccess), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" The chosen badge and how to award it, above the grid (Ames\n             2026-10-27: \"if I select one the award input should be added at\n             the top\"). "),
                ($setup.awardBadgeId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                      ($setup.awardBadge)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                            (($setup.awardBadge.thumbnail_url || $setup.awardBadge.image_url) && !$setup.brokenBadgeImg.has($setup.awardBadge.id))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.awardBadge.thumbnail_url || $setup.awardBadge.image_url,
                                  class: "nge-admin-badge-img nge-admin-badge-img--sm",
                                  onError: _cache[46] || (_cache[46] = $event => ($setup.onBadgeImgError($setup.awardBadge.id)))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_168))
                              : (_openBlock(), _createElementBlock("span", _hoisted_169, "🏅")),
                            _createElementVNode("span", _hoisted_170, _toDisplayString($setup.awardBadge.name), 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "nge-admin-action-btn",
                              onClick: _cache[47] || (_cache[47] = $event => ($setup.awardBadgeId = null))
                            }, "Change")
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("label", _hoisted_172, [
                          _createElementVNode("input", {
                            type: "file",
                            accept: "image/png,image/jpeg,image/webp,image/gif",
                            class: "nge-admin-file-input",
                            disabled: $setup.badgeImageBusy,
                            onChange: $setup.replaceBadgeImage
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_173),
                          _createTextVNode(" " + _toDisplayString($setup.badgeImageBusy ? 'Replacing…' : 'Replace this award’s picture...'), 1 /* TEXT */)
                        ]),
                        ($setup.badgeImageNote)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_174, _toDisplayString($setup.badgeImageNote), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _hoisted_175,
                      _createElementVNode("div", _hoisted_176, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => (($setup.awardUserSearch) = $event)),
                          onInput: $setup.onAwardUserSearch,
                          class: "nge-admin-input",
                          placeholder: "Search by name or email..."
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelText, $setup.awardUserSearch]
                        ])
                      ]),
                      ($setup.awardUserResults.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.awardUserResults, (u) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: u.id,
                                class: "nge-admin-search-item",
                                onClick: $event => ($setup.awardToUser(u.id, u.display_name || u.email))
                              }, " Award to " + _toDisplayString(u.display_name || u.email), 9 /* TEXT, PROPS */, _hoisted_178))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _hoisted_179,
                      _createElementVNode("div", _hoisted_180, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => (($setup.awardGroupId) = $event)),
                          class: "nge-admin-select"
                        }, [
                          _hoisted_181,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.backend.groups, (g) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: g.id,
                              value: g.id
                            }, _toDisplayString(g.name), 9 /* TEXT, PROPS */, _hoisted_182))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $setup.awardGroupId]
                        ]),
                        _createElementVNode("button", {
                          class: "nge-admin-action-btn",
                          disabled: !$setup.awardGroupId,
                          onClick: $setup.awardToGroup
                        }, "Award to Group", 8 /* PROPS */, _hoisted_183)
                      ])
                    ], 512 /* NEED_PATCH */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_184, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => (($setup.badgeFind) = $event)),
                    class: "nge-admin-input",
                    placeholder: "Find a badge by name..."
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.badgeFind]
                  ]),
                  _createElementVNode("span", _hoisted_185, _toDisplayString($setup.filteredBadges.length) + " " + _toDisplayString($setup.filteredBadges.length === 1 ? 'badge' : 'badges'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_186, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pagedBadges, (b) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: b.id,
                      class: _normalizeClass(["nge-admin-badge-card", { 'nge-admin-badge-card--selected': $setup.awardBadgeId === b.id }]),
                      onClick: $event => ($setup.selectBadgeForAward(b.id)),
                      title: b.description || b.name
                    }, [
                      ((b.thumbnail_url || b.image_url) && !$setup.brokenBadgeImg.has(b.id))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: b.thumbnail_url || b.image_url,
                            class: "nge-admin-badge-img",
                            loading: "lazy",
                            onError: $event => ($setup.onBadgeImgError(b.id))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_188))
                        : (_openBlock(), _createElementBlock("span", _hoisted_189, "🏅")),
                      _createElementVNode("div", _hoisted_190, _toDisplayString(b.name), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_187))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                ($setup.badgePages > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                      _createElementVNode("button", {
                        class: "nge-admin-action-btn",
                        disabled: $setup.badgePage === 0,
                        onClick: _cache[51] || (_cache[51] = $event => ($setup.badgePage--))
                      }, "‹ Back", 8 /* PROPS */, _hoisted_192),
                      _createElementVNode("span", _hoisted_193, "Page " + _toDisplayString($setup.badgePage + 1) + " of " + _toDisplayString($setup.badgePages), 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "nge-admin-action-btn",
                        disabled: $setup.badgePage >= $setup.badgePages - 1,
                        onClick: _cache[52] || (_cache[52] = $event => ($setup.badgePage++))
                      }, "Next ›", 8 /* PROPS */, _hoisted_194)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ═══ PRACTICE CELLS (resettable Cut & Merge examples) ═══ "),
    ($setup.adminSubTab === 'practice')
      ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
          _createElementVNode("div", _hoisted_196, [
            _hoisted_197,
            _hoisted_198,
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("label", _hoisted_200, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: "cut",
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => (($setup.practiceKind) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, $setup.practiceKind]
                ]),
                _createTextVNode(" Cut example: leave the cell fused. A and B are two spots on it, one on each side of where the cut should go")
              ]),
              _createElementVNode("label", _hoisted_201, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: "merge_then_cut",
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => (($setup.practiceKind) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, $setup.practiceKind]
                ]),
                _createTextVNode(" Merge example: B is wrongly disconnected from A, the learner merges it back")
              ])
            ]),
            _createElementVNode("div", { class: "nge-admin-row" }, [
              _createElementVNode("button", {
                class: "nge-admin-primary-btn",
                onClick: $setup.startPicking
              }, "Pick A and B in the viewer"),
              _hoisted_202
            ]),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              ($setup.practicePicking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                    _hoisted_204,
                    _createElementVNode("span", _hoisted_205, [
                      _createTextVNode("Hovered: "),
                      _createElementVNode("code", null, _toDisplayString($setup.practiceHover ? $setup.practiceHover.root : 'move over a segment'), 1 /* TEXT */),
                      ($setup.practiceHover && !$setup.practiceHover.sv)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_206, " (hover it in 2D for the exact spot)"))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_207,
                    _createElementVNode("span", _hoisted_208, [
                      _createTextVNode("A: "),
                      _createElementVNode("code", null, _toDisplayString($setup.pickLabel($setup.practiceA)), 1 /* TEXT */),
                      _createTextVNode(" B: "),
                      _createElementVNode("code", null, _toDisplayString($setup.pickLabel($setup.practiceB)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                      class: "nge-admin-primary-btn",
                      onClick: $setup.stopPicking
                    }, "Back to Admin Hub")
                  ]))
                : _createCommentVNode("v-if", true)
            ])),
            _createElementVNode("div", _hoisted_209, [
              _createElementVNode("span", null, [
                _createTextVNode("A: "),
                _createElementVNode("code", null, _toDisplayString($setup.pickLabel($setup.practiceA)), 1 /* TEXT */)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode("B: "),
                _createElementVNode("code", null, _toDisplayString($setup.pickLabel($setup.practiceB)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_210, [
              _hoisted_211,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => (($setup.practiceRootA) = $event)),
                class: "nge-admin-input nge-admin-input--sm",
                placeholder: "root A"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.practiceRootA]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => (($setup.practiceRootB) = $event)),
                class: "nge-admin-input nge-admin-input--sm",
                placeholder: "root B"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.practiceRootB]
              ])
            ]),
            _createElementVNode("div", _hoisted_212, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => (($setup.practiceTitle) = $event)),
                class: "nge-admin-input",
                placeholder: "Title, e.g. Pyramidal cell, missing apical branch"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.practiceTitle]
              ]),
              _createElementVNode("button", {
                class: "nge-admin-primary-btn",
                disabled: $setup.practiceSaving || !$setup.practiceA || !$setup.practiceB,
                onClick: $setup.registerPractice
              }, _toDisplayString($setup.practiceSaving ? 'Saving…' : 'Register'), 9 /* TEXT, PROPS */, _hoisted_213)
            ]),
            ($setup.practiceError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_214, "⚠ " + _toDisplayString($setup.practiceError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.practiceNotice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_215, _toDisplayString($setup.practiceNotice), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_216, [
            _createElementVNode("label", { class: "nge-admin-label" }, [
              _createTextVNode("Practice cells "),
              _createElementVNode("button", {
                class: "nge-admin-action-btn",
                style: {"margin-left":"8px"},
                onClick: $setup.loadPractice
              }, "Refresh")
            ]),
            ($setup.practiceLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_217, "Loading…"))
              : (!$setup.practiceRows.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_218, "None registered yet. Tutorial 3 tells learners every cell is busy until one exists."))
                : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.practiceRows, (ex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ex.id,
                class: _normalizeClass(["nge-practice-row", 'nge-practice-row--' + ex.status])
              }, [
                _createElementVNode("div", _hoisted_219, [
                  _createElementVNode("strong", null, _toDisplayString(ex.title), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_220, _toDisplayString(ex.status) + _toDisplayString(ex.enabled ? '' : ', disabled'), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_221, _toDisplayString(ex.kind === 'cut' ? 'cut example' : 'merge example'), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_222, [
                    _createTextVNode(_toDisplayString(ex.dataset) + " · used " + _toDisplayString(ex.uses) + "×", 1 /* TEXT */),
                    (ex.last_reset_at)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · reset " + _toDisplayString($setup.practiceWhen(ex.last_reset_at)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (ex.claimed_by)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" · claimed until " + _toDisplayString($setup.practiceWhen(ex.expires_at)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (ex.last_error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_223, _toDisplayString(ex.last_error), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_224, [
                  _createElementVNode("button", {
                    class: "nge-admin-action-btn",
                    disabled: $setup.practiceActing === ex.id,
                    onClick: $event => ($setup.checkPractice(ex))
                  }, "Check", 8 /* PROPS */, _hoisted_225),
                  _createElementVNode("button", {
                    class: "nge-admin-action-btn",
                    disabled: $setup.practiceActing === ex.id,
                    onClick: $event => ($setup.resetPracticeNow(ex))
                  }, "Reset now", 8 /* PROPS */, _hoisted_226),
                  _createElementVNode("button", {
                    class: "nge-admin-action-btn",
                    disabled: $setup.practiceActing === ex.id,
                    onClick: $event => ($setup.patchPractice(ex.id, { enabled: !ex.enabled }))
                  }, _toDisplayString(ex.enabled ? 'Disable' : 'Enable'), 9 /* TEXT, PROPS */, _hoisted_227),
                  _createElementVNode("button", {
                    class: "nge-admin-action-btn",
                    disabled: $setup.practiceActing === ex.id,
                    onClick: $event => ($setup.deletePractice(ex))
                  }, "Delete", 8 /* PROPS */, _hoisted_228)
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ═══ TRIAGE (agent proposals awaiting human review) ═══ "),
    ($setup.adminSubTab === 'triage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
          _createCommentVNode(" Board view leaves the panel for the whole window. Teleported: the\n           profile panel's backdrop filter would otherwise trap a fixed box. "),
          (_openBlock(), _createBlock(_Teleport, {
            to: "body",
            disabled: !$setup.triageBoard || $props.standalone
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["nge-admin-block", { 'nge-triage-board': $setup.triageBoard, 'nge-triage-light': $setup.triageBoard && $setup.triageLight }])
            }, [
              _createCommentVNode(" The admins' own To do board, in place of the reports (Ames 2026-10-19). "),
              ($setup.todoView)
                ? (_openBlock(), _createBlock($setup["TodoBoard"], {
                    key: 0,
                    light: $setup.triageBoard && $setup.triageLight,
                    "focus-id": $setup.todoFocus,
                    "report-numbers": $setup.triageNumbers,
                    standalone: $props.standalone,
                    onBack: _cache[58] || (_cache[58] = $event => {$setup.todoView = false; $setup.loadTriage()})
                  }, null, 8 /* PROPS */, ["light", "focus-id", "report-numbers", "standalone"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    ($setup.arcaneOpen)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "nge-arcane-shelf",
                          onClick: _cache[60] || (_cache[60] = _withModifiers($event => ($setup.arcaneOpen = false), ["self"]))
                        }, [
                          _createElementVNode("div", _hoisted_230, [
                            _createElementVNode("button", {
                              class: "nge-arcane-close",
                              "aria-label": "Close",
                              onClick: _cache[59] || (_cache[59] = $event => ($setup.arcaneOpen = false))
                            }, "×"),
                            _hoisted_231,
                            _createElementVNode("div", _hoisted_232, [
                              _createTextVNode(_toDisplayString($setup.arcane.reports) + " reports closed with Done, " + _toDisplayString($setup.arcane.cards) + " To do " + _toDisplayString($setup.arcane.cards === 1 ? 'card' : 'cards') + " finished, at 5 each: ", 1 /* TEXT */),
                              _createElementVNode("b", null, _toDisplayString($setup.arcane.total), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_233, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.arcane.tiers, (t) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: t.at,
                                  class: _normalizeClass(["nge-arcane-tier", { 'nge-arcane-tier--locked': t.at > $setup.arcane.total }])
                                }, [
                                  (t.at <= $setup.arcane.total)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: t.art,
                                        alt: ""
                                      }, null, 8 /* PROPS */, _hoisted_234))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_235, "?")),
                                  _createElementVNode("div", _hoisted_236, _toDisplayString(t.at <= $setup.arcane.total ? t.name : 'A secret'), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_237, _toDisplayString(t.at <= $setup.arcane.total ? t.at.toLocaleString() : `at ${t.at.toLocaleString()}, ${$setup.arcane.toGo} to go`), 1 /* TEXT */)
                                ], 2 /* CLASS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.arcaneUnlock)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "nge-arcane-unlock",
                          role: "status",
                          onClick: _cache[61] || (_cache[61] = $event => ($setup.arcaneUnlock = null))
                        }, [
                          _createElementVNode("div", _hoisted_238, [
                            _createElementVNode("img", {
                              src: $setup.arcaneUnlock.art,
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_239),
                            _hoisted_240,
                            _createElementVNode("div", _hoisted_241, _toDisplayString($setup.arcaneUnlock.name), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_242, _toDisplayString($setup.arcaneUnlock.at.toLocaleString()) + " Pyr fixes", 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_243, [
                      _hoisted_244,
                      _createCommentVNode(" The page on its own has no game around it: a way back, in a new\n               tab so the board stays open (Ames 2026-10-12). "),
                      ($props.standalone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "nge-admin-action-btn nge-triage-newtab",
                            href: $setup.gameUrl,
                            target: "_blank",
                            rel: "noopener",
                            title: "Opens Pyr in a new tab. This page stays open."
                          }, "Open Pyr ↗"))
                        : _createCommentVNode("v-if", true),
                      (!$props.standalone)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "nge-admin-action-btn",
                            onClick: _cache[62] || (_cache[62] = $event => ($setup.triageBoard = !$setup.triageBoard)),
                            title: $setup.triageBoard ? 'Back to the list in the Admin Hub (Esc)' : 'Fill the window: one column per section'
                          }, _toDisplayString($setup.triageBoard ? '✕ Close board' : '▦ Board view'), 9 /* TEXT, PROPS */, _hoisted_245))
                        : _createCommentVNode("v-if", true),
                      (!$props.standalone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "nge-admin-action-btn nge-triage-newtab",
                            href: $setup.boardUrl,
                            target: "_blank",
                            rel: "noopener",
                            title: "Open the triage board on its own page, without the game"
                          }, "↗ New tab"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: "nge-admin-action-btn nge-triage-todo-open",
                        onClick: $setup.openTodoBoard,
                        title: "The admins' own planning board: To do, Doing, Done"
                      }, [
                        _createElementVNode("span", { innerHTML: $setup.TODO_ICON }),
                        _createTextVNode("To do board")
                      ]),
                      _createCommentVNode(" Pyr Patchtacular: my own Achievements. "),
                      ($setup.arcane.total > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "nge-arcane",
                            role: "button",
                            tabindex: "0",
                            onClick: _cache[63] || (_cache[63] = $event => ($setup.arcaneOpen = !$setup.arcaneOpen)),
                            onKeydown: _cache[64] || (_cache[64] = _withKeys($event => ($setup.arcaneOpen = !$setup.arcaneOpen), ["enter"])),
                            title: `Pyr Patchtacular: ${$setup.arcane.reports} reports closed with Done, ${$setup.arcane.cards} To do cards finished (5 each)`
                          }, [
                            ($setup.arcane.current)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.arcane.current.art,
                                  alt: "",
                                  class: "nge-arcane-art"
                                }, null, 8 /* PROPS */, _hoisted_247))
                              : (_openBlock(), _createElementBlock("span", _hoisted_248, "✦")),
                            _createElementVNode("div", _hoisted_249, [
                              _createElementVNode("div", _hoisted_250, _toDisplayString($setup.arcane.current ? $setup.arcane.current.name : 'Pyr Patchtacular'), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_251, [
                                _createElementVNode("span", {
                                  style: _normalizeStyle({ width: $setup.arcane.fill + '%' })
                                }, null, 4 /* STYLE */)
                              ]),
                              _createElementVNode("div", _hoisted_252, [
                                _createElementVNode("b", null, _toDisplayString($setup.arcane.total), 1 /* TEXT */),
                                _createTextVNode(" fixes · " + _toDisplayString($setup.arcane.toGo) + " to the next", 1 /* TEXT */)
                              ])
                            ])
                          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_246))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-triage-score", { 'nge-triage-score--lit': !!$setup.triageCheer }])
                      }, [
                        _createCommentVNode(" Level: one for every 25 reports closed. The ring fills toward the next. "),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-hud-level", { 'nge-hud-level--up': $setup.triageCheer?.levelUp }]),
                          title: `${$setup.triageScore.total} closed in all. ${$setup.triageScore.toGo} to go to level ${$setup.triageGame.level + 1}.`
                        }, [
                          _createElementVNode("div", {
                            class: "nge-hud-ring",
                            style: _normalizeStyle({ '--fill': $setup.triageScore.fill + '%' })
                          }, [
                            _createElementVNode("div", _hoisted_254, [
                              _hoisted_255,
                              _createElementVNode("b", null, _toDisplayString($setup.triageGame.level), 1 /* TEXT */)
                            ])
                          ], 4 /* STYLE */),
                          _createElementVNode("div", _hoisted_256, [
                            _createElementVNode("div", _hoisted_257, _toDisplayString($setup.triageGame.rank), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_258, [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ width: $setup.triageScore.fill + '%' })
                              }, null, 4 /* STYLE */)
                            ]),
                            _createElementVNode("div", _hoisted_259, [
                              _createElementVNode("b", null, _toDisplayString($setup.triageScore.toGo), 1 /* TEXT */),
                              _createTextVNode(" to go to level " + _toDisplayString($setup.triageGame.level + 1), 1 /* TEXT */)
                            ])
                          ])
                        ], 10 /* CLASS, PROPS */, _hoisted_253),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--bug", { 'nge-triage-score-item--pop': $setup.triageCheer?.kind === 'bug' }])
                        }, [
                          _hoisted_260,
                          _createElementVNode("b", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.triageTally.bugs
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _createElementVNode("span", _hoisted_261, _toDisplayString($setup.triageTally.bugs === 1 ? 'bug' : 'bugs') + " fixed", 1 /* TEXT */)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--feature", { 'nge-triage-score-item--pop': $setup.triageCheer?.kind === 'feature' }])
                        }, [
                          _hoisted_262,
                          _createElementVNode("b", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.triageTally.features
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _createElementVNode("span", _hoisted_263, _toDisplayString($setup.triageTally.features === 1 ? 'feature' : 'features') + " shipped", 1 /* TEXT */)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--other", { 'nge-triage-score-item--pop': $setup.triageCheer?.kind === 'other' }]),
                          title: "Closed reports filed as Other, and any that were not a bug or an idea"
                        }, [
                          _hoisted_264,
                          _createElementVNode("b", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.triageTally.other
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _hoisted_265
                        ], 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--today", { 'nge-triage-score-item--pop': !!$setup.triageCheer, 'nge-triage-score-item--record': $setup.triageGame.record }]),
                          title: $setup.triageGame.best ? `Best day so far: ${$setup.triageGame.best} closed` : undefined
                        }, [
                          _createElementVNode("span", _hoisted_267, _toDisplayString($setup.triageGame.record ? '🏆' : $setup.triageTally.today ? '🔥' : '☕'), 1 /* TEXT */),
                          _createElementVNode("b", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.triageTally.today
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _createElementVNode("span", _hoisted_268, _toDisplayString($setup.triageGame.record ? 'today, a new best' : 'closed today'), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_266),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--streak", { 'nge-triage-score-item--cold': !$setup.triageGame.streak }]),
                          title: $setup.triageGame.streak ? ($setup.triageGame.streakAtRisk ? 'Close one today to keep the streak going' : 'Days in a row with a report closed') : 'Close one today to start a streak'
                        }, [
                          _createElementVNode("span", _hoisted_270, _toDisplayString($setup.triageGame.streak ? '⚡' : '💤'), 1 /* TEXT */),
                          _createElementVNode("b", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.triageGame.streak
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _createElementVNode("span", _hoisted_271, _toDisplayString($setup.triageGame.streak === 1 ? 'day' : 'days') + " in a row", 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_269),
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-triage-score-item nge-triage-score-item--inbox", { 'nge-triage-score-item--zero': !$setup.triageGame.waiting }]),
                          title: "Reports waiting for your decision"
                        }, [
                          _createElementVNode("span", _hoisted_272, _toDisplayString($setup.triageGame.waiting ? '📥' : '🎉'), 1 /* TEXT */),
                          ($setup.triageGame.waiting)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("b", null, [
                                  _createVNode($setup["RollUp"], {
                                    value: $setup.triageGame.waiting
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _hoisted_273
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_274, "Triage zero"))
                        ], 2 /* CLASS */),
                        _createCommentVNode(" Today's Nurro: a different one each day (Ames 2026-10-10). "),
                        _createElementVNode("div", _hoisted_275, [
                          _createElementVNode("img", {
                            src: $setup.todaysNurro,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_276)
                        ]),
                        _createCommentVNode(" The last 14 days, one bar a day. "),
                        _createElementVNode("div", _hoisted_277, [
                          _createElementVNode("div", _hoisted_278, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.triageGame.spark, (d) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: d.key,
                                class: _normalizeClass(["nge-hud-spark-bar", { 'nge-hud-spark-bar--today': d.today, 'nge-hud-spark-bar--none': !d.n }]),
                                style: _normalizeStyle({ height: d.h + '%' }),
                                title: `${d.label}: ${d.n} closed`
                              }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_279))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _hoisted_280
                        ]),
                        ($setup.repoStats)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                              _createElementVNode("div", null, [
                                _createElementVNode("b", null, [
                                  _createVNode($setup["RollUp"], {
                                    value: $setup.repoStats.commits
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _hoisted_282
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("b", null, [
                                  _createVNode($setup["RollUp"], {
                                    value: $setup.repoStats.deploys
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _hoisted_283
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => (($setup.triageSearch) = $event)),
                        class: "nge-triage-search",
                        type: "search",
                        placeholder: "Search reports, or #number",
                        "aria-label": "Search reports",
                        onKeydown: [
                          _cache[66] || (_cache[66] = _withModifiers(() => {}, ["stop"])),
                          _cache[69] || (_cache[69] = _withKeys(_withModifiers($event => ($setup.triageSearch = ''), ["stop"]), ["esc"]))
                        ],
                        onKeyup: _cache[67] || (_cache[67] = _withModifiers(() => {}, ["stop"])),
                        onKeypress: _cache[68] || (_cache[68] = _withModifiers(() => {}, ["stop"]))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelText, $setup.triageSearch]
                      ]),
                      ($setup.triageWords.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_284, _toDisplayString($setup.triageMatchCount) + " of " + _toDisplayString($setup.triageRows.length), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_285, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TRIAGE_KINDS, (k) => {
                          return _createElementVNode("button", {
                            key: k.key,
                            type: "button",
                            role: "radio",
                            class: _normalizeClass(["nge-triage-kind", { 'nge-triage-kind--on': $setup.triageKind === k.key }]),
                            title: "Open reports of this kind. The board shows only these.",
                            "aria-checked": $setup.triageKind === k.key ? 'true' : 'false',
                            onClick: $event => ($setup.triageKind = k.key)
                          }, [
                            _createTextVNode(_toDisplayString(k.label) + " ", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_287, _toDisplayString($setup.triageKindCount[k.key]), 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_286)
                        }), 64 /* STABLE_FRAGMENT */))
                      ]),
                      ($setup.triageBoard)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 5,
                            class: "nge-admin-action-btn",
                            "aria-pressed": $setup.triageLight ? 'true' : 'false',
                            title: $setup.triageLight ? 'Switch to the dark page' : 'Switch to a light page, easier for reading a lot of text',
                            onClick: $setup.toggleTriageLight
                          }, _toDisplayString($setup.triageLight ? '☾ Dark' : '☀ Light'), 9 /* TEXT, PROPS */, _hoisted_288))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("label", _hoisted_289, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => (($setup.triageShowReviewed) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $setup.triageShowReviewed]
                        ]),
                        _hoisted_290
                      ]),
                      _createElementVNode("button", {
                        class: "nge-admin-action-btn",
                        onClick: $setup.loadTriage,
                        disabled: $setup.triageLoading
                      }, "↻ Refresh", 8 /* PROPS */, _hoisted_291)
                    ]),
                    _hoisted_292,
                    ($setup.zeroParty)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: $setup.zeroParty,
                          class: "nge-zero-party",
                          role: "status",
                          onClick: _cache[71] || (_cache[71] = $event => ($setup.zeroParty = 0))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ZERO_BITS, (c, i) => {
                            return (_openBlock(), _createElementBlock("i", {
                              key: i,
                              class: _normalizeClass(["nge-zero-bit", { 'nge-zero-bit--wide': c.wide }]),
                              style: _normalizeStyle({ left: c.left + '%', background: c.color, animationDelay: c.delay + 's', animationDuration: c.dur + 's', '--r': c.rot + 'deg' })
                            }, null, 6 /* CLASS, STYLE */))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createElementVNode("div", _hoisted_293, [
                            _createElementVNode("img", {
                              src: $setup.nurroConfetti,
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_294),
                            _hoisted_295,
                            _hoisted_296
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_Transition, { name: "nge-triage-cheer" }, {
                      default: _withCtx(() => [
                        ($setup.triageCheer)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: $setup.triageCheer.key,
                              class: _normalizeClass(["nge-triage-cheer", `nge-triage-cheer--${$setup.triageCheer.kind}`]),
                              role: "status"
                            }, [
                              _hoisted_297,
                              _hoisted_298,
                              _createElementVNode("span", _hoisted_299, _toDisplayString($setup.triageCheer.text), 1 /* TEXT */)
                            ], 2 /* CLASS */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    ($setup.triageError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_300, "⚠ " + _toDisplayString($setup.triageError), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.dupNotice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_301, "✓ " + _toDisplayString($setup.dupNotice), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.triageLoading && !$setup.triageRows.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_302, "Loading…"))
                      : (!$setup.triageRows.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_303, " No proposals waiting. The agent runs on a schedule; new feedback shows up here after its next pass. "))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: "nge-triage-cols",
                      style: _normalizeStyle($setup.triageBoard ? { gridTemplateColumns: $setup.boardColumns } : undefined)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.triageGroups, (g) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: g.key,
                          class: _normalizeClass(["nge-triage-col", [`nge-triage-col--${g.key}`, { 'nge-triage-col--folded': $setup.triageBoard && $setup.isFolded(g.key) }]])
                        }, [
                          ($setup.triageRows.length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["nge-triage-group", { 'nge-triage-group--open': $setup.triageOpen[g.key], 'nge-triage-group--empty': !g.rows.length }]),
                                "aria-expanded": ($setup.triageBoard ? !$setup.isFolded(g.key) : $setup.triageOpen[g.key]) ? 'true' : 'false',
                                title: $setup.triageBoard ? ($setup.isFolded(g.key) ? `Open ${g.title}` : `Fold ${g.title} away`) : undefined,
                                onClick: $event => ($setup.triageBoard ? $setup.toggleFold(g.key) : ($setup.triageOpen[g.key] = !$setup.triageOpen[g.key]))
                              }, [
                                _hoisted_305,
                                _createElementVNode("span", _hoisted_306, _toDisplayString(g.icon), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_307, _toDisplayString(g.title), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_308, _toDisplayString(g.rows.length), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_309, _toDisplayString(g.hint), 1 /* TEXT */)
                              ], 10 /* CLASS, PROPS */, _hoisted_304))
                            : _createCommentVNode("v-if", true),
                          ($setup.triageBoard ? !$setup.isFolded(g.key) : $setup.triageOpen[g.key])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rows, (row) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: row.id,
                                    class: _normalizeClass(["nge-triage-card", [`nge-triage-card--${row.recommendation}`, { 'nge-triage-card--closed': g.closed, 'nge-triage-card--selected': $setup.triageSelected === row.id, 'nge-triage-card--reply': $setup.hasNewReply(row), 'nge-triage-card--waiting': $setup.isAwaitingReply(row) }]]),
                                    "data-triage-id": row.id,
                                    onClick: $event => ($setup.triageSelected = row.id)
                                  }, [
                                    _createElementVNode("div", _hoisted_311, [
                                      ($setup.triageNumbers[row.id])
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "nge-triage-num",
                                            title: 'Report number ' + $setup.triageNumbers[row.id]
                                          }, "#" + _toDisplayString($setup.triageNumbers[row.id]), 9 /* TEXT, PROPS */, _hoisted_312))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.dupOf(row))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "nge-triage-dup-badge",
                                            title: 'Grouped into report #' + ($setup.triageNumbers[$setup.dupOf(row) || ''] || '')
                                          }, "Same as #" + _toDisplayString($setup.triageNumbers[$setup.dupOf(row) || ''] || '?'), 9 /* TEXT, PROPS */, _hoisted_313))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.dupsOf(row).length)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 2,
                                            class: "nge-triage-dup-badge nge-triage-dup-badge--main",
                                            title: 'Also reported by ' + $setup.dupsOf(row).map(d => ($setup.reporterOf(d)?.name || 'someone') + ' (#' + ($setup.triageNumbers[d.id] || '?') + ')').join(', ')
                                          }, "+" + _toDisplayString($setup.dupsOf(row).length) + " same", 9 /* TEXT, PROPS */, _hoisted_314))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.hasNewReply(row))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_315, "💬 New reply"))
                                        : _createCommentVNode("v-if", true),
                                      (row.admin_notes?.length)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 4,
                                            class: "nge-triage-impl nge-triage-notes-chip",
                                            title: `${row.admin_notes.length} note${row.admin_notes.length === 1 ? '' : 's'} from admins`
                                          }, "📝 " + _toDisplayString(row.admin_notes.length), 9 /* TEXT, PROPS */, _hoisted_316))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.isAwaitingReply(row))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 5,
                                            class: "nge-triage-rec nge-triage-rec--waiting",
                                            title: 'You asked the submitter for a reply' + ($setup.awaitingReplySince(row) ? ' ' + $setup.ago($setup.awaitingReplySince(row) || '') + ' ago' : '') + ' and it has not come yet. It comes back under Needs your decision when it does.'
                                          }, [
                                            _createTextVNode("⏳ Waiting on their reply"),
                                            ($setup.awaitingReplySince(row))
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" · " + _toDisplayString($setup.ago($setup.awaitingReplySince(row) || '')), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ], 8 /* PROPS */, _hoisted_317))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["nge-triage-rec", $setup.isNewReport(row) ? 'nge-triage-rec--new' : `nge-triage-rec--${row.recommendation}`])
                                      }, _toDisplayString($setup.isNewReport(row) ? 'New report' : $setup.hadNoSuggestion(row) ? 'No suggestion' : $setup.TRIAGE_LABELS[row.recommendation]), 3 /* TEXT, CLASS */),
                                      _createElementVNode("span", _hoisted_318, _toDisplayString(row.source.replace('_', ' ')), 1 /* TEXT */),
                                      (row.status !== 'proposed')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_319, [
                                            _createTextVNode(_toDisplayString(row.status), 1 /* TEXT */),
                                            (row.reviewed_by)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" · " + _toDisplayString(row.reviewed_by.startsWith('slack:') ? 'in Slack' : row.reviewed_by), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.isByHand(row))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_320, "by hand"))
                                        : _createCommentVNode("v-if", true),
                                      (row.impl_state)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 8,
                                            class: _normalizeClass(["nge-triage-impl", `nge-triage-impl--${row.impl_state}`])
                                          }, _toDisplayString($setup.IMPL_LABELS[row.impl_state]), 3 /* TEXT, CLASS */))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.slackThreadUrl(row))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 9,
                                            class: "nge-triage-link",
                                            href: $setup.slackThreadUrl(row) || undefined,
                                            target: "_blank",
                                            rel: "noopener"
                                          }, "Slack thread", 8 /* PROPS */, _hoisted_321))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    ($setup.reporterOf(row))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_322, [
                                          _createElementVNode("span", {
                                            class: "nge-triage-avatar",
                                            "aria-hidden": "true",
                                            style: _normalizeStyle({ '--hue': $setup.avatarHue($setup.reporterOf(row)?.name || '') })
                                          }, _toDisplayString(($setup.reporterOf(row)?.name || '?').slice(0, 1).toUpperCase()), 5 /* TEXT, STYLE */),
                                          _hoisted_323,
                                          _createElementVNode("strong", null, _toDisplayString($setup.reporterOf(row)?.name), 1 /* TEXT */),
                                          ($setup.reporterOf(row)?.category)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · " + _toDisplayString($setup.reporterOf(row)?.category), 1 /* TEXT */)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true),
                                          ($setup.reporterOf(row)?.at)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(" · "),
                                                _createElementVNode("span", {
                                                  class: "nge-triage-when",
                                                  title: $setup.shortDate($setup.reporterOf(row)?.at || '')
                                                }, _toDisplayString($setup.shortDate($setup.reporterOf(row)?.at || '')), 9 /* TEXT, PROPS */, _hoisted_324),
                                                _createElementVNode("span", {
                                                  class: "nge-triage-ago",
                                                  title: $setup.shortDate($setup.reporterOf(row)?.at || '')
                                                }, _toDisplayString($setup.ago($setup.reporterOf(row)?.at || '')), 9 /* TEXT, PROPS */, _hoisted_325)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.reporterOf(row)?.title)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_326, _toDisplayString($setup.reporterOf(row)?.title), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" A one line report is all title: say it once. "),
                                    ($setup.fullTextOf(row) && $setup.fullTextOf(row) !== $setup.reporterOf(row)?.title)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_327, [
                                          _createTextVNode("\""),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts($setup.fullTextOf(row)), (pt, pi) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                              (pt.href)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    class: "nge-triage-link",
                                                    href: pt.href,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    onClick: _cache[72] || (_cache[72] = _withModifiers(() => {}, ["stop"]))
                                                  }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_328))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                  ], 64 /* STABLE_FRAGMENT */))
                                            ], 64 /* STABLE_FRAGMENT */))
                                          }), 128 /* KEYED_FRAGMENT */)),
                                          _createTextVNode("\"")
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (row.source === 'site_issue')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
                                          ($setup.reporterOf(row)?.url)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "nge-triage-console-btn nge-triage-view-btn",
                                                href: $setup.reporterOf(row)?.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                onClick: _cache[73] || (_cache[73] = _withModifiers(() => {}, ["stop"])),
                                                title: "The view they were in when they sent the report"
                                              }, "↗ Open their view", 8 /* PROPS */, _hoisted_330))
                                            : _createCommentVNode("v-if", true),
                                          ($setup.reporterOf(row)?.shot)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                class: "nge-triage-console-btn nge-triage-view-btn",
                                                href: $setup.reporterOf(row)?.shot,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                onClick: _cache[74] || (_cache[74] = _withModifiers(() => {}, ["stop"])),
                                                title: "The screenshot they attached"
                                              }, "🖼 Screenshot", 8 /* PROPS */, _hoisted_331))
                                            : _createCommentVNode("v-if", true),
                                          _createElementVNode("button", {
                                            class: "nge-triage-console-btn",
                                            onClick: $event => ($setup.toggleIssueConsole(row))
                                          }, _toDisplayString($setup.issueConsole[row.id] === undefined ? '🖥 Console messages' : $setup.issueConsoleOpen[row.id] ? '▾ Console messages' : '▸ Console messages'), 9 /* TEXT, PROPS */, _hoisted_332),
                                          _createCommentVNode(" Copy the whole log (Ames 2026-10-21: \"we need a copy button for console logs\"). "),
                                          ($setup.issueConsoleOpen[row.id] && $setup.issueConsole[row.id])
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "nge-triage-console-btn",
                                                title: "Copy all the console messages",
                                                onClick: _withModifiers($event => ($setup.copyText($setup.issueConsole[row.id] || '')), ["stop"])
                                              }, _toDisplayString($setup.copied === $setup.issueConsole[row.id] ? '✓ Copied' : '📋 Copy'), 9 /* TEXT, PROPS */, _hoisted_333))
                                            : _createCommentVNode("v-if", true),
                                          ($setup.issueConsoleOpen[row.id])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_334, [
                                                _createCommentVNode(" Also on the log itself, where the eye is (Ames 2026-10-23: \"I need a copy console logs button\"). "),
                                                ($setup.issueConsole[row.id])
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "nge-triage-console-copy",
                                                      title: "Copy all the console messages",
                                                      onClick: _withModifiers($event => ($setup.copyText($setup.issueConsole[row.id] || '')), ["stop"])
                                                    }, _toDisplayString($setup.copied === $setup.issueConsole[row.id] ? '✓ Copied' : '📋 Copy logs'), 9 /* TEXT, PROPS */, _hoisted_335))
                                                  : _createCommentVNode("v-if", true),
                                                _createElementVNode("pre", _hoisted_336, _toDisplayString($setup.issueConsole[row.id] || 'No console messages were attached to this report.'), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.isNewReport(row))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_337, _toDisplayString($setup.suggestAsked(row) ? 'Claude is reading the code. A suggested fix will appear on this card in a few minutes; press Refresh.' : 'No suggestion has been asked for. Fix it by hand, or ask Claude to suggest a fix (one Claude run).'), 1 /* TEXT */))
                                      : (row.rationale && !$setup.hadNoSuggestion(row))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_338, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(row.rationale), (pt, pi) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                (pt.href)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      class: "nge-triage-link",
                                                      href: pt.href,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer",
                                                      onClick: _cache[75] || (_cache[75] = _withModifiers(() => {}, ["stop"]))
                                                    }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_339))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                    (row.recommendation === 'message' && row.status === 'proposed')
                                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 6,
                                          "onUpdate:modelValue": $event => (($setup.triageEdits[row.id]) = $event),
                                          class: "nge-triage-message",
                                          rows: "3",
                                          onKeydown: _cache[76] || (_cache[76] = _withModifiers(() => {}, ["stop"])),
                                          onKeyup: _cache[77] || (_cache[77] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[78] || (_cache[78] = _withModifiers(() => {}, ["stop"]))
                                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_340)), [
                                          [$setup["vAutogrow"]],
                                          [_vModelText, $setup.triageEdits[row.id]]
                                        ])
                                      : (row.proposed_message)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                                            _createTextVNode("💬 "),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(row.proposed_message), (pt, pi) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                (pt.href)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      class: "nge-triage-link",
                                                      href: pt.href,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer",
                                                      onClick: _cache[79] || (_cache[79] = _withModifiers(() => {}, ["stop"]))
                                                    }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_342))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                    (row.spec)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_343, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseSpec(row.spec), (line, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: i,
                                              class: "nge-triage-spec-row"
                                            }, [
                                              (line.label)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_344, _toDisplayString(line.label), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("span", _hoisted_345, _toDisplayString(line.text), 1 /* TEXT */)
                                            ]))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (row.approver_note)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_346, [
                                          _hoisted_347,
                                          _createElementVNode("span", _hoisted_348, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(row.approver_note), (pt, pi) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                (pt.href)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      class: "nge-triage-link",
                                                      href: pt.href,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer",
                                                      onClick: _cache[80] || (_cache[80] = _withModifiers(() => {}, ["stop"]))
                                                    }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_349))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (row.impl_state)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_350, [
                                          (row.impl_summary)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_351, [
                                                _hoisted_352,
                                                _createTextVNode(" " + _toDisplayString(row.impl_summary), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (row.preview_url)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_353, [
                                                _hoisted_354,
                                                _createTextVNode(),
                                                _createElementVNode("a", {
                                                  href: row.preview_url,
                                                  target: "_blank",
                                                  rel: "noopener"
                                                }, _toDisplayString(row.preview_url), 9 /* TEXT, PROPS */, _hoisted_355)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (row.impl_state === 'testing' || row.impl_state === 'live_testing' || row.impl_state === 'needs_info')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_356, [
                                                _hoisted_357,
                                                _createTextVNode(" the tester in the Slack thread" + _toDisplayString(row.impl_state === 'needs_info' ? ', to answer Claude' : '') + ". Reminded " + _toDisplayString(row.nag_count || 0) + " time" + _toDisplayString(row.nag_count === 1 ? '' : 's') + ".", 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.feedback_log || []).slice(-3), (f) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: f.ts
                                            }, [
                                              _createElementVNode("span", _hoisted_358, _toDisplayString($setup.roleLabel(f.role)), 1 /* TEXT */),
                                              _createTextVNode(),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(f.text), (pt, pi) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                  (pt.href)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        class: "nge-triage-link",
                                                        href: pt.href,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        onClick: _cache[81] || (_cache[81] = _withModifiers(() => {}, ["stop"]))
                                                      }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_359))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                      ], 64 /* STABLE_FRAGMENT */))
                                                ], 64 /* STABLE_FRAGMENT */))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                          }), 128 /* KEYED_FRAGMENT */)),
                                          (row.impl_run_url)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_360, [
                                                _createElementVNode("a", {
                                                  href: row.impl_run_url,
                                                  target: "_blank",
                                                  rel: "noopener"
                                                }, "Claude's run log", 8 /* PROPS */, _hoisted_361),
                                                (row.impl_attempts)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(" · attempt " + _toDisplayString(row.impl_attempts), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : _createCommentVNode("v-if", true)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Notes from admins, with no decision (Celia #178). "),
                                    _createElementVNode("div", {
                                      class: "nge-triage-notes",
                                      onClick: _cache[85] || (_cache[85] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.admin_notes || [], (n, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: i,
                                          class: "nge-triage-note nge-triage-admin-note"
                                        }, [
                                          _hoisted_362,
                                          _createElementVNode("span", _hoisted_363, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(n.text), (pt, pi) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                ($setup.isNoteImage(pt.href))
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      class: "nge-triage-note-pic",
                                                      href: pt.href,
                                                      target: "_blank",
                                                      rel: "noopener noreferrer"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: pt.href,
                                                        alt: "An image on this note",
                                                        loading: "lazy"
                                                      }, null, 8 /* PROPS */, _hoisted_365)
                                                    ], 8 /* PROPS */, _hoisted_364))
                                                  : (pt.href)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 1,
                                                        class: "nge-triage-link",
                                                        href: pt.href,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                      }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_366))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                      ], 64 /* STABLE_FRAGMENT */))
                                              ], 64 /* STABLE_FRAGMENT */))
                                            }), 128 /* KEYED_FRAGMENT */)),
                                            _createElementVNode("span", _hoisted_367, " · " + _toDisplayString(n.by) + ", " + _toDisplayString($setup.relTime(n.at)), 1 /* TEXT */)
                                          ])
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */)),
                                      ($setup.noteOpen[row.id])
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _withDirectives(_createElementVNode("textarea", {
                                              "onUpdate:modelValue": $event => (($setup.noteDrafts[row.id]) = $event),
                                              class: "nge-triage-message nge-triage-comment",
                                              rows: "2",
                                              maxlength: "2000",
                                              placeholder: "A note for the admins. Nothing else changes. Type @Celia to tag her. Paste a screenshot to add it.",
                                              onPaste: $event => ($setup.onNotePaste($event, row)),
                                              onInput: $event => ($setup.onTagInput($event, v => $setup.noteDrafts[row.id] = v)),
                                              onKeydown: $setup.onTagKey,
                                              onBlur: _cache[82] || (_cache[82] = $event => ($setup.tagPicker = null)),
                                              onKeyup: _cache[83] || (_cache[83] = _withModifiers(() => {}, ["stop"])),
                                              onKeypress: _cache[84] || (_cache[84] = _withModifiers(() => {}, ["stop"]))
                                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_368), [
                                              [$setup["vAutogrow"]],
                                              [_vModelText, $setup.noteDrafts[row.id]]
                                            ]),
                                            ($setup.taggedIn($setup.noteDrafts[row.id]).length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_369, [
                                                  _createTextVNode("Tagging "),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taggedIn($setup.noteDrafts[row.id]), (p) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                      key: p.id,
                                                      class: "nge-triage-tag-chip"
                                                    }, "@" + _toDisplayString(p.name), 1 /* TEXT */))
                                                  }), 128 /* KEYED_FRAGMENT */))
                                                ]))
                                              : _createCommentVNode("v-if", true),
                                            ($setup.noteImages[row.id])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_370, [
                                                  ($setup.noteImages[row.id].preview)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: $setup.noteImages[row.id].preview,
                                                        alt: "The image going with this note"
                                                      }, null, 8 /* PROPS */, _hoisted_371))
                                                    : _createCommentVNode("v-if", true),
                                                  _createElementVNode("span", _hoisted_372, _toDisplayString($setup.noteImages[row.id].error || ($setup.noteImages[row.id].uploading ? 'Uploading…' : 'Goes with this note.')), 1 /* TEXT */),
                                                  _createElementVNode("button", {
                                                    class: "nge-admin-action-btn",
                                                    type: "button",
                                                    onClick: $event => ($setup.dropNoteImage(row))
                                                  }, "Remove", 8 /* PROPS */, _hoisted_373)
                                                ]))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_374, [
                                              _createElementVNode("label", _hoisted_375, [
                                                _createTextVNode("🖼 Add image"),
                                                _createElementVNode("input", {
                                                  type: "file",
                                                  accept: "image/png,image/jpeg,image/webp,image/gif",
                                                  hidden: "",
                                                  onChange: $event => ($setup.onNoteFile($event, row))
                                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_376)
                                              ]),
                                              _createElementVNode("button", {
                                                class: "nge-admin-primary-btn",
                                                disabled: $setup.noteSaving === row.id || $setup.noteImages[row.id]?.uploading || !($setup.noteDrafts[row.id]?.trim() || $setup.noteImages[row.id]?.url),
                                                onClick: $event => ($setup.saveNote(row))
                                              }, _toDisplayString($setup.noteSaving === row.id ? 'Saving…' : 'Save note'), 9 /* TEXT, PROPS */, _hoisted_377),
                                              _createElementVNode("button", {
                                                class: "nge-admin-action-btn",
                                                disabled: $setup.noteSaving === row.id,
                                                onClick: $event => ($setup.noteOpen[row.id] = false)
                                              }, "Cancel", 8 /* PROPS */, _hoisted_378)
                                            ])
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "nge-admin-action-btn nge-triage-note-btn",
                                            title: "Leave a note for the admins. Nothing else on the card changes, nothing is sent to the submitter, and the robot ignores it.",
                                            onClick: $event => ($setup.noteOpen[row.id] = true)
                                          }, "📝 Add a note", 8 /* PROPS */, _hoisted_379))
                                    ]),
                                    _createCommentVNode(" Reviewer comment, saved with Approve or Dismiss. Internal: it is\n               never sent to the reporter (the message box above is). "),
                                    (row.status === 'proposed')
                                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 11,
                                          "onUpdate:modelValue": $event => (($setup.triageNotes[row.id]) = $event),
                                          class: "nge-triage-message nge-triage-comment",
                                          rows: "2",
                                          placeholder: "Comment (optional), saved with your decision. Type @Celia or @Marissa to tag them.",
                                          onInput: $event => ($setup.onTagInput($event, v => $setup.triageNotes[row.id] = v)),
                                          onKeydown: $setup.onTagKey,
                                          onBlur: _cache[86] || (_cache[86] = $event => ($setup.tagPicker = null)),
                                          onKeyup: _cache[87] || (_cache[87] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[88] || (_cache[88] = _withModifiers(() => {}, ["stop"]))
                                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_380)), [
                                          [$setup["vAutogrow"]],
                                          [_vModelText, $setup.triageNotes[row.id]]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    ($setup.taggedIn($setup.triageNotes[row.id]).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_381, [
                                          _createTextVNode("Tagging "),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taggedIn($setup.triageNotes[row.id]), (p) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: p.id,
                                              class: "nge-triage-tag-chip"
                                            }, "@" + _toDisplayString(p.name), 1 /* TEXT */))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (row.status === 'proposed' && $setup.hasTag($setup.triageNotes[row.id]))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_382, [
                                          _createElementVNode("button", {
                                            class: "nge-admin-primary-btn",
                                            disabled: $setup.noteSaving === row.id,
                                            title: "Saves this as a note on the card and notifies who you tagged, in Pyr and in the report's Slack thread. Nothing else on the card changes.",
                                            onClick: $event => ($setup.sendCommentTag(row))
                                          }, _toDisplayString($setup.noteSaving === row.id ? 'Sending…' : '💬 Send tag'), 9 /* TEXT, PROPS */, _hoisted_383)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" The decision first (Ames 2026-10-05), then the other tools. "),
                                    (row.status === 'proposed')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_384, [
                                          _createCommentVNode(" Suggest a fix is paused (Ames 2026-11-02: \"I don't want to be\n                 paying for this\"); its workflow, Triage Propose, is switched off. "),
                                          (!$setup.isNewReport(row))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "nge-admin-primary-btn",
                                                disabled: $setup.triageActing === row.id,
                                                onClick: $event => ($setup.setTriageStatus(row, 'approved'))
                                              }, _toDisplayString((row.recommendation === 'message' ? 'Approve + Send' : 'Approve') + ($setup.triageNotes[row.id]?.trim() ? ' with comment' : '')), 9 /* TEXT, PROPS */, _hoisted_385))
                                            : _createCommentVNode("v-if", true),
                                          _createElementVNode("button", {
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id,
                                            onClick: $event => ($setup.setTriageStatus(row, 'dismissed'))
                                          }, _toDisplayString($setup.triageNotes[row.id]?.trim() ? 'Dismiss with comment' : 'Dismiss'), 9 /* TEXT, PROPS */, _hoisted_386)
                                        ]))
                                      : (row.status === 'approved')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_387, [
                                            ($setup.isBuildable(row) && !row.impl_state && !$setup.isTodo(row))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "nge-admin-primary-btn",
                                                  disabled: $setup.triageActing === row.id,
                                                  onClick: $event => ($setup.setImplState(row, 'queued'))
                                                }, "Have Claude build it", 8 /* PROPS */, _hoisted_388))
                                              : _createCommentVNode("v-if", true),
                                            (row.impl_state === 'failed' && !$setup.releaseBuildOf(row))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "nge-admin-primary-btn",
                                                  disabled: $setup.triageActing === row.id,
                                                  onClick: $event => ($setup.setImplState(row, 'queued'))
                                                }, "Retry build", 8 /* PROPS */, _hoisted_389))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_390, [
                                      _createElementVNode("button", {
                                        class: "nge-admin-action-btn",
                                        onClick: $event => ($setup.openInClaude(row)),
                                        title: "Copies a full briefing and opens a new Claude chat with it. Paste the briefing into Claude Code to change the code."
                                      }, "Work on it with Claude", 8 /* PROPS */, _hoisted_391),
                                      _createCommentVNode(" Done, on every card that is not already done (Ames 2026-10-01:\n                 \"a lot of the time I fix in Claude\"), whatever state it is in:\n                 waiting for a decision, in progress, or dismissed. "),
                                      (row.status === 'proposed' || $setup.isLater(row) || $setup.isTodo(row))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id,
                                            title: "You are fixing this yourself, for example in a Claude chat. Moves the card to In progress. The robot does not build it and nothing is sent to the reporter.",
                                            onClick: $event => ($setup.markInProgress(row))
                                          }, "▶ In progress", 8 /* PROPS */, _hoisted_392))
                                        : _createCommentVNode("v-if", true),
                                      (row.status === 'proposed' || $setup.isByHand(row) || $setup.isLater(row))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id,
                                            title: "A bigger job to plan. Puts a card for it on the To do board and moves this report under On the To do board. The robot does not build it and nothing is sent to the reporter.",
                                            onClick: $event => ($setup.sendToTodoBoard(row))
                                          }, [
                                            _createElementVNode("span", { innerHTML: $setup.TODO_ICON }),
                                            _createTextVNode("To do")
                                          ], 8 /* PROPS */, _hoisted_393))
                                        : _createCommentVNode("v-if", true),
                                      (row.status === 'proposed' || $setup.isByHand(row) || $setup.isTodo(row))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id,
                                            title: "A good idea, but not now. Moves the card to Ideas for later. The robot does not build it and nothing is sent to the reporter.",
                                            onClick: $event => ($setup.markInProgress(row, true))
                                          }, "💡 Later", 8 /* PROPS */, _hoisted_394))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.triageGroupOf(row) !== 'done')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 3,
                                            class: "nge-admin-action-btn nge-triage-done-btn",
                                            disabled: $setup.triageActing === row.id,
                                            title: "It is fixed or handled. Moves this card to Done and posts the update in its Slack thread.",
                                            onClick: $event => ($setup.setTriageStatus(row, 'done'))
                                          }, "✓ Done", 8 /* PROPS */, _hoisted_395))
                                        : _createCommentVNode("v-if", true),
                                      _createCommentVNode(" Dismiss at any stage after approval too (a failed or unwanted\n                 build), and Discard for junk (Ames 2026-10-05). "),
                                      (row.status === 'approved')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 4,
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id || $setup.isGoingLive(row),
                                            title: $setup.isGoingLive(row) ? 'It is on, or on its way to, the live site. Revert it in the Slack thread first.' : 'It was built another way, so the robot is not needed. Stops its work, cancels any build in progress and moves the card to Dismissed.',
                                            onClick: $event => ($setup.setTriageStatus(row, 'dismissed', false, true))
                                          }, "Dismiss: built independently", 8 /* PROPS */, _hoisted_396))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.triageGroupOf(row) !== 'done' && !$setup.isDiscarded(row))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 5,
                                            class: "nge-admin-action-btn nge-triage-discard-btn",
                                            disabled: $setup.triageActing === row.id || $setup.isGoingLive(row),
                                            title: "Junk, a duplicate or a test: dismiss it and take it off the board. Still findable with Show older.",
                                            onClick: $event => ($setup.setTriageStatus(row, 'dismissed', true))
                                          }, "🗑 Discard", 8 /* PROPS */, _hoisted_397))
                                        : _createCommentVNode("v-if", true),
                                      (row.status === 'dismissed')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 6,
                                            class: "nge-admin-action-btn",
                                            disabled: $setup.triageActing === row.id,
                                            title: "Undo the dismiss: the report goes back under Needs your decision, with its history kept.",
                                            onClick: $event => ($setup.undismiss(row))
                                          }, "↩ Back to the board", 8 /* PROPS */, _hoisted_398))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.claudeCopied === row.id)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_399, "Briefing copied. Paste it into Claude Code to change the code."))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createCommentVNode(" Going live is approved in Slack only: the deploy checks the\n               tester's exact reply there before it touches the live site. "),
                                    (row.status === 'approved' && $setup.releaseBuildOf(row))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_400, [
                                          _hoisted_401,
                                          _createElementVNode("div", _hoisted_402, [
                                            _createElementVNode("button", {
                                              class: "nge-admin-primary-btn",
                                              disabled: $setup.triageActing === row.id,
                                              onClick: $event => ($setup.releaseFromHub(row, 'final')),
                                              title: "Deploys this build to the live community site. The same as replying good with the build ID in Slack."
                                            }, "🚀 Deploy to the live site", 8 /* PROPS */, _hoisted_403),
                                            _createElementVNode("button", {
                                              class: "nge-admin-action-btn",
                                              disabled: $setup.triageActing === row.id,
                                              onClick: $event => ($setup.releaseFromHub(row, 'live_test')),
                                              title: "Puts it on the live site as a test, for things only the live site can show. Keep or revert it in the Slack thread."
                                            }, "Live test", 8 /* PROPS */, _hoisted_404)
                                          ]),
                                          _hoisted_405,
                                          _createElementVNode("div", _hoisted_406, [
                                            _createElementVNode("code", null, "good " + _toDisplayString($setup.releaseBuildOf(row)), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "nge-admin-action-btn",
                                              onClick: $event => ($setup.copyText('good ' + $setup.releaseBuildOf(row)))
                                            }, _toDisplayString($setup.copied === 'good ' + $setup.releaseBuildOf(row) ? 'Copied' : 'Copy'), 9 /* TEXT, PROPS */, _hoisted_407)
                                          ]),
                                          _createElementVNode("div", _hoisted_408, [
                                            _createElementVNode("code", null, "ship to test " + _toDisplayString($setup.releaseBuildOf(row)), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "nge-admin-action-btn",
                                              onClick: $event => ($setup.copyText('ship to test ' + $setup.releaseBuildOf(row)))
                                            }, _toDisplayString($setup.copied === 'ship to test ' + $setup.releaseBuildOf(row) ? 'Copied' : 'Copy'), 9 /* TEXT, PROPS */, _hoisted_409)
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Optional note to the person who filed the report. Drafted from\n               the card's state; edit, send, or close it and nothing is sent.\n               Slack threads get the same thing via \"update reporter\". "),
                                    _createCommentVNode(" A beta access request is granted right here (Ames 2026-10-26:\n               \"so admin could grant them access from here?\"). "),
                                    ($setup.betaEmailOfCard(row) && $setup.triageGroupOf(row) !== 'done')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_410, [
                                          _createElementVNode("button", {
                                            class: "nge-admin-action-btn nge-triage-done-btn",
                                            disabled: $setup.triageActing === row.id || $setup.cardLetInBusy === row.id,
                                            title: 'Adds ' + $setup.betaEmailOfCard(row) + ' to Pilot testers, then moves this card to Done.',
                                            onClick: $event => ($setup.letInFromCard(row))
                                          }, _toDisplayString($setup.cardLetInBusy === row.id ? 'Adding…' : '🔑 Let them in'), 9 /* TEXT, PROPS */, _hoisted_411),
                                          _createElementVNode("span", _hoisted_412, _toDisplayString($setup.betaEmailOfCard(row)), 1 /* TEXT */),
                                          (!$setup.props.standalone)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "nge-triage-link nge-triage-beta-open",
                                                type: "button",
                                                onClick: _cache[89] || (_cache[89] = $event => ($setup.adminSubTab = 'pilot'))
                                              }, "Open Beta requests"))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.cardLetInError[row.id])
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_413, _toDisplayString($setup.cardLetInError[row.id]), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (row.source === 'site_issue')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_414, [
                                          _createCommentVNode(" The thread, oldest first: what was sent, and any reply asked for. "),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reporterThreadFor(row), (u) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: u.role + u.ts,
                                              class: _normalizeClass(["nge-triage-note", { 'nge-triage-note--reply': u.reply, 'nge-triage-note--unread': u.reply && u.seen === false }])
                                            }, [
                                              _createElementVNode("span", _hoisted_415, _toDisplayString(u.reply ? 'Submitter replied' : 'Sent to submitter'), 1 /* TEXT */),
                                              (!u.reply)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_416, [
                                                    _createElementVNode("div", {
                                                      class: "nge-admin-fmtpreview-body",
                                                      innerHTML: $setup.renderSafeMarkdown(u.text, true)
                                                    }, null, 8 /* PROPS */, _hoisted_417),
                                                    (u.image_url)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          href: u.image_url,
                                                          target: "_blank",
                                                          rel: "noopener",
                                                          class: "nge-triage-reply-shot",
                                                          title: "Open the image you sent"
                                                        }, [
                                                          _createElementVNode("img", {
                                                            src: u.image_url,
                                                            alt: "Image sent with this reply",
                                                            loading: "lazy"
                                                          }, null, 8 /* PROPS */, _hoisted_419)
                                                        ], 8 /* PROPS */, _hoisted_418))
                                                      : (u.image_removed)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_420, "Image removed after 7 days. "))
                                                        : _createCommentVNode("v-if", true),
                                                    _createElementVNode("span", _hoisted_421, _toDisplayString(u.by || (u.reply ? 'the submitter' : 'Slack')) + _toDisplayString(u.at ? ', ' + $setup.relTime(u.at) : '') + _toDisplayString(u.ask ? (u.waiting ? ' · asked for a reply, none yet' : ' · asked for a reply') : '') + _toDisplayString(u.reply && u.seen === false ? ' · new' : ''), 1 /* TEXT */)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_422, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkParts(u.text), (pt, pi) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                        (pt.href)
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 0,
                                                              class: "nge-triage-link",
                                                              href: pt.href,
                                                              target: "_blank",
                                                              rel: "noopener noreferrer",
                                                              onClick: _cache[90] || (_cache[90] = _withModifiers(() => {}, ["stop"]))
                                                            }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_423))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                      ], 64 /* STABLE_FRAGMENT */))
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    _createElementVNode("span", _hoisted_424, " · " + _toDisplayString(u.by || (u.reply ? 'the submitter' : 'Slack')) + _toDisplayString(u.at ? ', ' + $setup.relTime(u.at) : '') + _toDisplayString(u.ask ? (u.waiting ? ' · asked for a reply, none yet' : ' · asked for a reply') : '') + _toDisplayString(u.reply && u.seen === false ? ' · new' : ''), 1 /* TEXT */)
                                                  ])),
                                              _createCommentVNode(" What came with a reply: a screenshot, their view, console messages. "),
                                              (u.reply && (u.screenshot_url || u.view_url || u.console_lines || u.dataset))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_425, [
                                                    (u.screenshot_url)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          href: u.screenshot_url,
                                                          target: "_blank",
                                                          rel: "noopener",
                                                          class: "nge-triage-reply-shot",
                                                          title: "Open the full screenshot"
                                                        }, [
                                                          _createElementVNode("img", {
                                                            src: u.screenshot_url,
                                                            alt: "Screenshot sent with the reply",
                                                            loading: "lazy"
                                                          }, null, 8 /* PROPS */, _hoisted_427)
                                                        ], 8 /* PROPS */, _hoisted_426))
                                                      : _createCommentVNode("v-if", true),
                                                    _createElementVNode("div", _hoisted_428, [
                                                      (u.view_url)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            href: u.view_url,
                                                            target: "_blank",
                                                            rel: "noopener",
                                                            class: "nge-triage-chip"
                                                          }, "↗ Open their view", 8 /* PROPS */, _hoisted_429))
                                                        : _createCommentVNode("v-if", true),
                                                      (u.console_lines)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 1,
                                                            type: "button",
                                                            class: "nge-triage-chip",
                                                            onClick: $event => ($setup.toggleReplyConsole(u.notification_id))
                                                          }, _toDisplayString($setup.replyConsoleOpen[u.notification_id] ? '▾' : '▸') + " Console messages (" + _toDisplayString(u.console_lines) + ") ", 9 /* TEXT, PROPS */, _hoisted_430))
                                                        : _createCommentVNode("v-if", true),
                                                      (u.console_lines && $setup.replyConsoleOpen[u.notification_id] && $setup.replyConsole[u.notification_id])
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 2,
                                                            type: "button",
                                                            class: "nge-triage-chip",
                                                            title: "Copy all the console messages",
                                                            onClick: $event => ($setup.copyText($setup.replyConsole[u.notification_id] || ''))
                                                          }, _toDisplayString($setup.copied === $setup.replyConsole[u.notification_id] ? '✓ Copied' : '📋 Copy'), 9 /* TEXT, PROPS */, _hoisted_431))
                                                        : _createCommentVNode("v-if", true),
                                                      (u.dataset)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_432, _toDisplayString(u.dataset) + _toDisplayString(u.build ? ' · ' + u.build : ''), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                    ]),
                                                    (u.console_lines && $setup.replyConsoleOpen[u.notification_id])
                                                      ? (_openBlock(), _createElementBlock("pre", _hoisted_433, _toDisplayString($setup.replyConsole[u.notification_id] === undefined ? 'Loading…' : ($setup.replyConsole[u.notification_id] ?? 'These messages are no longer stored.')), 1 /* TEXT */))
                                                      : _createCommentVNode("v-if", true)
                                                  ]))
                                                : _createCommentVNode("v-if", true)
                                            ], 2 /* CLASS */))
                                          }), 128 /* KEYED_FRAGMENT */)),
                                          ($setup.hasNewReply(row))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "nge-admin-action-btn nge-triage-reporter-open",
                                                disabled: $setup.triageActing === row.id,
                                                title: "Takes the New reply marker off. The card goes back to where it was; nothing else about it changes.",
                                                onClick: $event => ($setup.markRepliesSeen(row))
                                              }, "✓ Reply read", 8 /* PROPS */, _hoisted_434))
                                            : _createCommentVNode("v-if", true),
                                          ($setup.reporterDrafts[row.id] !== undefined)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" Lists and bold, as the player will see them (Ames 2026-10-16).\n                   The text is Markdown; the feed draws it through\n                   renderSafeMarkdown, never as raw HTML. "),
                                                _createElementVNode("div", _hoisted_435, [
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    title: "Bold",
                                                    onClick: $event => ($setup.fmtWrap('**', 'bold text', $setup.reporterComposer(row)))
                                                  }, _hoisted_438, 8 /* PROPS */, _hoisted_436),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    title: "Bulleted list: each selected line becomes a bullet",
                                                    onClick: $event => ($setup.fmtLines('- ', 'List item', $setup.reporterComposer(row)))
                                                  }, "• Bullets", 8 /* PROPS */, _hoisted_439),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    title: "Numbered list: each selected line gets 1, 2, 3",
                                                    onClick: $event => ($setup.fmtLines(i => `${i + 1}. `, 'List item', $setup.reporterComposer(row)))
                                                  }, "1. Numbers", 8 /* PROPS */, _hoisted_440),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    title: "Add an image or screenshot. You can also paste or drop one into the box. It is deleted after 7 days.",
                                                    onClick: $event => ($setup.replyFileEls[row.id]?.click())
                                                  }, "🖼 Image", 8 /* PROPS */, _hoisted_441),
                                                  _createElementVNode("input", {
                                                    ref_for: true,
                                                    ref: el => $setup.setReplyFileEl(row, el),
                                                    type: "file",
                                                    accept: "image/png,image/jpeg,image/gif,image/webp",
                                                    hidden: "",
                                                    onChange: $event => ($setup.onReplyFile($event, row))
                                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_442),
                                                  _hoisted_443,
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    class: "nge-triage-preview-toggle",
                                                    "aria-pressed": $setup.replyPreviewOpen[row.id] ? 'true' : 'false',
                                                    title: "Show the message as the player will see it",
                                                    onClick: $event => ($setup.replyPreviewOpen[row.id] = !$setup.replyPreviewOpen[row.id])
                                                  }, _toDisplayString($setup.replyPreviewOpen[row.id] ? 'Hide preview' : 'Preview'), 9 /* TEXT, PROPS */, _hoisted_444)
                                                ]),
                                                _withDirectives(_createElementVNode("textarea", {
                                                  ref_for: true,
                                                  ref: el => { $setup.reporterEls[row.id] = el; },
                                                  "onUpdate:modelValue": $event => (($setup.reporterDrafts[row.id]) = $event),
                                                  class: "nge-triage-message nge-triage-comment",
                                                  rows: "6",
                                                  onPaste: $event => ($setup.onReplyPaste($event, row)),
                                                  onDragover: _cache[91] || (_cache[91] = _withModifiers(() => {}, ["prevent"])),
                                                  onDrop: _withModifiers($event => ($setup.onReplyDrop($event, row)), ["prevent"]),
                                                  onKeydown: _cache[92] || (_cache[92] = _withModifiers(() => {}, ["stop"])),
                                                  onKeyup: _cache[93] || (_cache[93] = _withModifiers(() => {}, ["stop"])),
                                                  onKeypress: _cache[94] || (_cache[94] = _withModifiers(() => {}, ["stop"]))
                                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_445), [
                                                  [$setup["vAutogrow"]],
                                                  [_vModelText, $setup.reporterDrafts[row.id]]
                                                ]),
                                                ($setup.replyImages[row.id])
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_446, [
                                                      ($setup.replyImages[row.id].preview)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: $setup.replyImages[row.id].preview,
                                                            alt: "The image going with this reply"
                                                          }, null, 8 /* PROPS */, _hoisted_447))
                                                        : _createCommentVNode("v-if", true),
                                                      _createElementVNode("span", _hoisted_448, _toDisplayString($setup.replyImages[row.id].error || ($setup.replyImages[row.id].uploading ? 'Uploading…' : 'Goes with this reply. Deleted after 7 days.')), 1 /* TEXT */),
                                                      _createElementVNode("button", {
                                                        type: "button",
                                                        class: "nge-admin-action-btn",
                                                        title: "Remove the image",
                                                        onClick: $event => ($setup.dropReplyImage(row))
                                                      }, "✕", 8 /* PROPS */, _hoisted_449)
                                                    ]))
                                                  : _createCommentVNode("v-if", true),
                                                _createCommentVNode(" Only when asked for (Ames 2026-10-16: \"I keep accidentally clicking there\"). "),
                                                ($setup.replyPreviewOpen[row.id] && $setup.reporterDrafts[row.id]?.trim())
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_450, [
                                                      _hoisted_451,
                                                      _createElementVNode("div", {
                                                        class: "nge-admin-fmtpreview-body",
                                                        innerHTML: $setup.renderSafeMarkdown($setup.reporterDrafts[row.id], true)
                                                      }, null, 8 /* PROPS */, _hoisted_452)
                                                    ]))
                                                  : _createCommentVNode("v-if", true),
                                                _createCommentVNode(" Off / On, as a two way switch in the board's own style (Ames\n                   2026-10-13: \"the black check box is weird\"). The lit side\n                   is how it is now. "),
                                                _createElementVNode("div", _hoisted_453, [
                                                  _createElementVNode("span", {
                                                    id: 'nge-triage-ask-' + row.id,
                                                    class: "nge-triage-ask-label"
                                                  }, "Ask for a reply", 8 /* PROPS */, _hoisted_454),
                                                  _createElementVNode("div", {
                                                    class: "nge-triage-switch",
                                                    role: "radiogroup",
                                                    "aria-labelledby": 'nge-triage-ask-' + row.id,
                                                    "data-on": $setup.reporterAsk[row.id] ? 'on' : 'off'
                                                  }, [
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      role: "radio",
                                                      class: "nge-triage-switch-opt",
                                                      "aria-checked": $setup.reporterAsk[row.id] ? 'false' : 'true',
                                                      tabindex: $setup.reporterAsk[row.id] ? -1 : 0,
                                                      disabled: $setup.reporterSending === row.id,
                                                      onClick: $event => ($setup.reporterAsk[row.id] = false),
                                                      onKeydown: [
                                                        _withKeys(_withModifiers($event => ($setup.reporterAsk[row.id] = true), ["prevent","stop"]), ["right"]),
                                                        _withKeys(_withModifiers($event => ($setup.reporterAsk[row.id] = false), ["prevent","stop"]), ["left"])
                                                      ]
                                                    }, "Off", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_456),
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      role: "radio",
                                                      class: "nge-triage-switch-opt nge-triage-switch-opt--on",
                                                      "aria-checked": $setup.reporterAsk[row.id] ? 'true' : 'false',
                                                      tabindex: $setup.reporterAsk[row.id] ? 0 : -1,
                                                      disabled: $setup.reporterSending === row.id,
                                                      onClick: $event => ($setup.reporterAsk[row.id] = true),
                                                      onKeydown: [
                                                        _withKeys(_withModifiers($event => ($setup.reporterAsk[row.id] = true), ["prevent","stop"]), ["right"]),
                                                        _withKeys(_withModifiers($event => ($setup.reporterAsk[row.id] = false), ["prevent","stop"]), ["left"])
                                                      ]
                                                    }, "On", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_457)
                                                  ], 8 /* PROPS */, _hoisted_455),
                                                  _createElementVNode("span", _hoisted_458, _toDisplayString($setup.reporterAsk[row.id]
                  ? 'They get a reply form under your message: text, a screenshot, their view and console messages. One reply. Ask again to hear more.'
                  : 'They get your message only.'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_459, [
                                                  _createElementVNode("button", {
                                                    class: "nge-admin-primary-btn",
                                                    disabled: $setup.reporterSending === row.id || !$setup.reporterDrafts[row.id]?.trim(),
                                                    onClick: $event => ($setup.sendReporterUpdate(row))
                                                  }, _toDisplayString($setup.reporterSending === row.id ? 'Sending…' : $setup.reporterAsk[row.id] ? 'Send and ask for a reply' : 'Send to submitter'), 9 /* TEXT, PROPS */, _hoisted_460),
                                                  ($setup.triageGroupOf(row) !== 'done')
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "nge-admin-action-btn nge-triage-done-btn",
                                                        disabled: $setup.reporterSending === row.id || $setup.triageActing === row.id || !$setup.reporterDrafts[row.id]?.trim(),
                                                        title: "Sends this to the submitter, then moves the card to Done with the same text as its note.",
                                                        onClick: $event => ($setup.sendReporterUpdate(row, true))
                                                      }, "✓ Send and mark done", 8 /* PROPS */, _hoisted_461))
                                                    : _createCommentVNode("v-if", true),
                                                  ($setup.triageGroupOf(row) === 'decide')
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "nge-admin-action-btn",
                                                        disabled: $setup.reporterSending === row.id || $setup.triageActing === row.id || !$setup.reporterDrafts[row.id]?.trim(),
                                                        title: "Sends this to the submitter, then moves the card to In progress, marked by hand so the robot does not build it.",
                                                        onClick: $event => ($setup.sendReporterUpdate(row, false, true))
                                                      }, "▶ Send: mark in progress", 8 /* PROPS */, _hoisted_462))
                                                    : _createCommentVNode("v-if", true),
                                                  ($setup.triageGroupOf(row) === 'decide' || $setup.isByHand(row))
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 2,
                                                        class: "nge-admin-action-btn",
                                                        disabled: $setup.reporterSending === row.id || $setup.triageActing === row.id || !$setup.reporterDrafts[row.id]?.trim(),
                                                        title: "Sends this to the submitter, then moves the card to Ideas for later.",
                                                        onClick: $event => ($setup.sendReporterUpdate(row, false, false, true))
                                                      }, "💡 Send: mark later", 8 /* PROPS */, _hoisted_463))
                                                    : _createCommentVNode("v-if", true),
                                                  _createElementVNode("button", {
                                                    class: "nge-admin-action-btn",
                                                    disabled: $setup.reporterSending === row.id,
                                                    onClick: $event => ($setup.closeReporterDraft(row))
                                                  }, "Not now", 8 /* PROPS */, _hoisted_464)
                                                ])
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "nge-admin-action-btn nge-triage-reporter-open",
                                                onClick: $event => ($setup.reporterDrafts[row.id] = $setup.draftReporterUpdate(row)),
                                                title: "Draft a notification to the person who reported this. You can edit it before sending, or not send it."
                                              }, "✉ Update submitter", 8 /* PROPS */, _hoisted_465))
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 10 /* CLASS, PROPS */, _hoisted_310))
                                }), 128 /* KEYED_FRAGMENT */)),
                                ($setup.triageBoard && !g.rows.length && !$setup.isFolded(g.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_466, [
                                      (g.key === 'decide')
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: $setup.imgNurroBravo,
                                            alt: "",
                                            class: "nge-triage-zero-nurro"
                                          }, null, 8 /* PROPS */, _hoisted_467))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", null, _toDisplayString(g.empty), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 4 /* STYLE */)
                  ], 64 /* STABLE_FRAGMENT */))
            ], 2 /* CLASS */)
          ], 8 /* PROPS */, ["disabled"]))
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.tagPicker && $setup.tagMatches.length)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: "nge-todo-mention nge-todo-mention--light",
            role: "listbox",
            style: _normalizeStyle({ left: $setup.tagPicker.el.getBoundingClientRect().left + 'px', top: $setup.tagPicker.el.getBoundingClientRect().bottom + 4 + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tagMatches, (p, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: p.id,
                role: "option",
                "aria-selected": i === $setup.tagPicker.pick ? 'true' : 'false',
                class: _normalizeClass({ 'nge-todo-mention--pick': i === $setup.tagPicker.pick }),
                onMousedown: _withModifiers($event => ($setup.pickTag(p)), ["prevent"])
              }, "@" + _toDisplayString(p.name), 43 /* TEXT, CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_468))
            }), 128 /* KEYED_FRAGMENT */))
          ], 4 /* STYLE */))
        : _createCommentVNode("v-if", true)
    ]))
  ]))
}